(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dabi-about-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.ready || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.dataset.ready = '1';
      const phs = [...root.querySelectorAll('.dabi-ah__ph')];
      let frame = null;
      const tick = () => {
        frame = null;
        const r = root.getBoundingClientRect();
        const p = Math.min(1, Math.max(-1, -r.top / Math.max(1, r.height)));
        phs.forEach((ph) => { ph.style.transform = `translate3d(0, ${(-p * 120 * parseFloat(ph.dataset.depth || '0.1')).toFixed(1)}px, 0)`; });
      };
      const q = () => { if (frame === null) frame = requestAnimationFrame(tick); };
      window.addEventListener('scroll', q, { passive: true });
      window.addEventListener('resize', q, { passive: true });
      tick();
    };
    const run = () => document.querySelectorAll('[data-dabi-ah]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-article-tools"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const content = document.querySelector('.article-template__content');

      // İlerleme çubuğu: yazının başı ile sonu arasındaki konum.
      const bar = root.querySelector('[data-dabi-read-bar]');
      if (bar && content) {
        let frame = null;
        const update = () => {
          frame = null;
          const r = content.getBoundingClientRect();
          const total = r.height - window.innerHeight * 0.6;
          const done = Math.min(1, Math.max(0, (-r.top + window.innerHeight * 0.2) / Math.max(total, 1)));
          bar.style.setProperty('--dabi-read', done.toFixed(3));
        };
        const queue = () => { if (frame === null) frame = requestAnimationFrame(update); };
        window.addEventListener('scroll', queue, { passive: true });
        window.addEventListener('resize', queue, { passive: true });
        update();
      }

      // İçindekiler
      if (root.dataset.toc !== 'true' || !content) return;
      const heads = Array.from(content.querySelectorAll('h2, h3'));
      if (heads.length < Number(root.dataset.tocMin || 3)) return;
      const slug = (t, i) => `bolum-${i + 1}-${t.toLowerCase().replace(/[^a-z0-9çğıöşü]+/gi, '-').replace(/^-|-$/g, '').slice(0, 40)}`;
      const nav = document.createElement('nav');
      nav.className = 'dabi-toc';
      nav.setAttribute('aria-label', root.dataset.tocLabel || '');
      const label = document.createElement('p');
      label.className = 'dabi-toc__label';
      label.textContent = root.dataset.tocLabel || '';
      const list = document.createElement('ol');
      const links = heads.map((h, i) => {
        if (!h.id) h.id = slug(h.textContent || '', i);
        const li = document.createElement('li');
        if (h.tagName === 'H3') li.className = 'is-sub';
        const a = document.createElement('a');
        a.href = `#${h.id}`;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        list.appendChild(li);
        return a;
      });
      nav.append(label, list);
      content.prepend(nav);
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            const idx = heads.indexOf(e.target);
            links.forEach((a, i) => a.classList.toggle('is-current', i === idx));
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        heads.forEach((h) => io.observe(h));
      }
    };
    document.querySelectorAll('[data-dabi-article-tools]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-dabi-article-tools]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-blog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const cloneInto = (list, items) => {
      items.forEach((li) => {
        const c = li.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-clone', '');
        c.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        list.appendChild(c);
      });
    };

    /* Gündem: içerik ekranı dolduracak kadar çoğaltılır, sonra tamamı bir kez
       daha eklenir; liste %50 kayınca başa sarar, dikiş görünmez. */
    const initWire = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const vp = root.querySelector('[data-blog-wire-vp]');
      const list = root.querySelector('[data-blog-wire-list]');
      if (!vp || !list || reduce()) return;
      const originals = Array.from(list.children);
      if (!originals.length) return;
      let guard = 0;
      while (list.scrollWidth < vp.clientWidth && guard < 12) {
        cloneInto(list, originals);
        guard += 1;
      }
      cloneInto(list, Array.from(list.children));
      const speed = Number(root.dataset.speed) || 40;
      list.style.setProperty('--dabi-wire-dur', `${Math.max(16, Math.round(list.scrollWidth / 2 / speed))}s`);
      root.classList.add('is-flowing');
      vp.addEventListener('pointerdown', () => root.classList.add('is-paused'));
      ['pointerup', 'pointercancel', 'pointerleave'].forEach((ev) => vp.addEventListener(ev, () => root.classList.remove('is-paused')));
    };

    /* Konu çubuğu: etkin çipi görünür alana getir, yapışınca gölge */
    const initBar = (bar) => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      const nav = bar.querySelector('.dabi-blog__tags');
      const active = nav?.querySelector('.is-active');
      if (nav && active && nav.scrollWidth > nav.clientWidth) {
        nav.scrollLeft = active.offsetLeft - nav.clientWidth / 2 + active.clientWidth / 2;
      }
      if (!('IntersectionObserver' in window)) return;
      const sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.className = 'dabi-blog__bar-sentinel';
      bar.before(sentinel);
      new IntersectionObserver(([e]) => bar.classList.toggle('is-stuck', !e.isIntersecting && e.boundingClientRect.top < 0), { rootMargin: '-1px 0px 0px 0px' }).observe(sentinel);
    };

    const init = (scope) => {
      scope.querySelectorAll('[data-blog-wire]').forEach(initWire);
      scope.querySelectorAll('[data-blog-bar]').forEach(initBar);
    };
    init(document);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-bundle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (fmt, cents) => {
      const n = (Number(cents) || 0) / 100;
      const parts = (dec, thou, digits) => { let [i, f] = n.toFixed(digits).split('.'); i = i.replace(/\B(?=(\d{3})+(?!\d))/g, thou); return f !== undefined ? `${i}${dec}${f}` : i; };
      const key = (fmt.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
      const map = { amount_no_decimals: parts('', ',', 0), amount_with_comma_separator: parts(',', '.', 2), amount_no_decimals_with_comma_separator: parts('', '.', 0), amount_with_apostrophe_separator: parts('.', "'", 2), amount_with_space_separator: parts(',', ' ', 2), amount_no_decimals_with_space_separator: parts('', ' ', 0) };
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, map[key] || parts('.', ',', 2)).replace(/<[^>]*>/g, '').trim();
    };

    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      const boxes = Array.from(root.querySelectorAll('[data-bundle-variant]'));
      if (boxes.length === 0) return;
      root.dataset.ready = 'true';
      const total = root.querySelector('[data-bundle-total]');
      const count = root.querySelector('[data-bundle-count]');
      const add = root.querySelector('[data-bundle-add]');
      const msg = root.querySelector('[data-bundle-msg]');
      const fmt = root.dataset.moneyFormat || ('{' + '{amount}' + '}');

      const recalc = () => {
        const on = boxes.filter((b) => b.checked);
        const sum = on.reduce((s, b) => s + Number(b.dataset.price || 0), 0);
        if (total) total.textContent = formatMoney(fmt, sum);
        if (count) count.textContent = on.length ? `(${on.length})` : '';
        if (add) add.disabled = on.length === 0;
      };
      boxes.forEach((b) => b.addEventListener('change', recalc));
      recalc();

      add?.addEventListener('click', async () => {
        const on = boxes.filter((b) => b.checked);
        if (on.length === 0) return;
        add.disabled = true;
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = { items: on.map((b) => ({ id: Number(b.dataset.bundleVariant), quantity: 1 })) };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        try {
          const url = (window.routes && window.routes.cart_add_url) || '/cart/add';
          const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
          const data = await res.json();
          if (data.status) throw new Error(data.description || data.message);
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'dabi-bundle', cartData: data });
          }
          if (cart && typeof cart.renderContents === 'function') {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(data);
          }
          if (msg) { msg.textContent = root.dataset.labelAdded; msg.classList.remove('is-bad'); msg.hidden = false; }
        } catch (err) {
          if (msg) { msg.textContent = err.message || root.dataset.labelError; msg.classList.add('is-bad'); msg.hidden = false; }
        }
        add.disabled = false;
      });
    };

    const boot = () => document.querySelectorAll('[data-dabi-bundle]').forEach(init);
    boot();
    // Craft, öneri bölümünü fetch ile yeniden basar; içerik gelince kur.
    const mo = new MutationObserver(boot);
    document.querySelectorAll('[data-dabi-bundle]').forEach((el) => mo.observe(el, { childList: true }));
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-dabi-bundle]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-campaign"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.dabiCampaignReady === 'true') return;
      root.dataset.dabiCampaignReady = 'true';
      const timer = root.querySelector('[data-dabi-campaign-timer]');
      const ends = Date.parse(root.dataset.ends || '');
      if (timer && !Number.isNaN(ends)) {
        const units = { d: timer.querySelector('[data-unit="d"]'), h: timer.querySelector('[data-unit="h"]'), m: timer.querySelector('[data-unit="m"]') };
        const tick = () => {
          const left = ends - Date.now();
          if (left <= 0) { root.hidden = true; return; }
          units.d.textContent = String(Math.floor(left / 86400000));
          units.h.textContent = String(Math.floor((left % 86400000) / 3600000));
          units.m.textContent = String(Math.floor((left % 3600000) / 60000));
          timer.hidden = false;
        };
        tick();
        window.setInterval(tick, 30000);
      }
      root.querySelector('[data-dabi-campaign-code]')?.addEventListener('click', async (event) => {
        const b = event.currentTarget;
        const code = b.dataset.dabiCampaignCode;
        try { await navigator.clipboard.writeText(code); } catch (err) { /* pano izni yok */ }
        b.classList.add('is-copied');
        const label = b.querySelector('.dabi-campaign__code-label');
        const old = label.textContent;
        label.textContent = b.dataset.labelCopied || old;
        window.setTimeout(() => { b.classList.remove('is-copied'); label.textContent = old; }, 2200);
      });
    };
    document.querySelectorAll('[data-dabi-campaign]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-dabi-campaign]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-catalog-orbit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    const initialise = (section) => {
      if (!section || section.dataset.dabiReady === 'on') return;
      section.dataset.dabiReady = 'on';

      const tabs = Array.from(section.querySelectorAll('[data-orbitcat-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-orbitcat-panel]'));
      const dwell = (Number(section.dataset.tabDwell) || 0) * 1000;
      const stripSpeed = Number(section.dataset.stripSpeed) || 30;

      /* Cember acikken alttaki serit durur; kapaninca ayarlanan gecikmeyle
         devam eder. Imlec karttan cembere gecince seridin pointerleave'i
         tetikleniyordu, bayrak onu engelliyor. */
      let orbitOpen = false;
      let resumeAt = 0;
      const resumeDelay = Number(section.dataset.stripResume ?? 600);

      section.style.setProperty('--dabi-oc-dwell', `${dwell}ms`);

      /* ---------- sekmeler ---------- */

      let index = 0;
      let timer = null;
      let hovering = false;

      const show = (next) => {
        index = (next + panels.length) % panels.length;
        panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
        tabs.forEach((tab, i) => {
          const on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-current', on ? 'true' : 'false');
          // Sureyi gosteren cizginin animasyonu her gecisde bastan baslasin.
          const bar = tab.querySelector('.dabi-orbitcat__tab-bar');
          if (bar) {
            bar.style.animation = 'none';
            void bar.offsetWidth;
            bar.style.animation = '';
          }
        });
      };

      const stop = () => {
        if (timer === null) return;
        window.clearInterval(timer);
        timer = null;
      };

      const start = () => {
        stop();
        if (dwell <= 0 || panels.length < 2 || reduceMotion.matches) return;
        timer = window.setInterval(() => {
          if (!hovering && !section.closest('.is-dabi-hold, .is-dabi-hold-mto, .is-dabi-hold-shelf')) show(index + 1);
        }, dwell);
      };

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
          show(i);
          start();
        });
      });

      section.addEventListener('pointerenter', () => { hovering = true; });
      section.addEventListener('pointerleave', () => { hovering = false; });
      section.addEventListener('focusin', () => { hovering = true; });

      start();

      /* ---------- seritlerin kesintisiz akisi ---------- */

      panels.forEach((panel) => {
        const strip = panel.querySelector('[data-orbitcat-strip]');
        const track = panel.querySelector('.dabi-orbitcat__track');
        if (!strip || !track) return;

        const gapOf = () => parseFloat(getComputedStyle(track).columnGap) || 0;
        const wrapAt = () => (track.scrollWidth + gapOf()) / 2;
        let last = 0;
        let paused = false;

        strip.addEventListener('pointerenter', () => { paused = true; });
        strip.addEventListener('pointerleave', () => { paused = false; });
        strip.addEventListener('pointerdown', () => { paused = true; });

        const tick = (now) => {
          // Gorunmeyen panelde kaydirmanin anlami yok.
          if (panel.classList.contains('is-active') && !paused && !orbitOpen && now >= resumeAt && !reduceMotion.matches && !strip.closest('.is-dabi-hold, .is-dabi-hold-mto, .is-dabi-hold-shelf')) {
            const wrap = wrapAt();
            if (wrap > 0 && track.scrollWidth > strip.clientWidth) {
              const delta = Math.min(now - last, 60);
              strip.scrollLeft += (stripSpeed * delta) / 1000;
              if (strip.scrollLeft >= wrap) strip.scrollLeft -= wrap;
            }
          }
          last = now;
          if (strip.isConnected) window.requestAnimationFrame(tick);
        };

        last = performance.now();
        window.requestAnimationFrame(tick);
      });

      /* ---------- cember ---------- */

      const orbits = Array.from(section.querySelectorAll('[data-orbitcat-orbit]'));
      if (orbits.length === 0 || section.dataset.orbitEnabled !== 'true' || !finePointer.matches) return;

      const layout = section.dataset.orbitLayout || 'sides';
      const baseItem = Number(section.dataset.orbitItem) || 78;
      const gap = Number(section.dataset.orbitGap ?? 8);
      const minGutter = Number(section.dataset.orbitGutter) || 200;
      // Ortadaki dairenin istenen capi: onizleme burada aciliyor.
      const hubWanted = Number(section.dataset.orbitHub) || 150;
      const maxSize = parseFloat(getComputedStyle(section).getPropertyValue('--dabi-oc-orbit')) || 420;
      const openDelay = Number(section.dataset.orbitOpen ?? 80);
      const closeDelay = Number(section.dataset.orbitClose ?? 600);
      const minItems = Math.max(1, Number(section.dataset.orbitMin) || 1);

      let orbitKey = '';
      let openTimer = null;
      let closeTimer = null;

      const cancelTimers = () => {
        window.clearTimeout(openTimer);
        window.clearTimeout(closeTimer);
        openTimer = null;
        closeTimer = null;
      };

      const hideOrbit = () => {
        cancelTimers();
        if (orbitOpen) resumeAt = performance.now() + resumeDelay;
        orbitOpen = false;
        orbits.forEach((o) => o.classList.remove('is-visible', 'is-paused'));
        orbitKey = '';
      };

      const scheduleHide = () => {
        window.clearTimeout(openTimer);
        openTimer = null;
        if (closeTimer !== null || !orbitOpen) return;
        closeTimer = window.setTimeout(hideOrbit, closeDelay);
      };

      /* Komsu iki oge arasindaki kiris = oge + aralik; boylece ogeler
         birbirine yakin ama ust uste degil. Ortadaki dugmeye de yer kalir.
         Sigmiyorsa oge ve yaricap birlikte kucultulur. */
      const geometry = (count, avail) => {
        let item = baseItem;
        const chord = (i) => i + gap;
        let r = count > 1 ? chord(item) / (2 * Math.sin(Math.PI / count)) : item * 0.9;
        // Ortadaki daire istenen capta kalsin: yaricap buna gore buyur.
        r = Math.max(r, hubWanted / 2 + gap + item / 2);
        let size = 2 * r + item;
        if (size > avail) {
          const k = avail / size;
          item *= k;
          r *= k;
          size = avail;
        }
        const center = Math.max(58, 2 * r - item - gap * 2);
        return { item, r, size, center };
      };

      const build = (orbit, items) => {
        const ring = orbit.querySelector('[data-orbitcat-ring]');
        ring.innerHTML = '';
        items.forEach((raw, i) => {
          const [src, href] = raw.split('::');
          if (!src) return;
          const slot = document.createElement('span');
          slot.className = 'dabi-orbitcat__slot';
          slot.style.setProperty('--dabi-oi', String(i));
          slot.style.setProperty('--dabi-on', String(items.length));
          const inner = document.createElement('i');
          const link = document.createElement('a');
          link.href = href || '#';
          link.tabIndex = -1;
          // Buyuyen pencere bu cemberin ortasindaki dairede acilsin; Incele de
          // en son uzerine gelinen urune gitsin.
          const hub = orbit.querySelector('[data-orbitcat-center]');
          if (hub && section.dataset.orbitHubPreview === 'true') link.dataset.dabiPeekAnchor = hub.id;
          link.addEventListener('pointerenter', () => {
            if (hub) hub.href = link.getAttribute('href');
          });
          const img = document.createElement('img');
          img.src = src;
          img.alt = '';
          img.width = 160;
          img.height = 160;
          img.loading = 'lazy';
          link.appendChild(img);
          inner.appendChild(link);
          slot.appendChild(inner);
          ring.appendChild(slot);
        });
      };

      const placeRing = (orbit, items, x, y, avail) => {
        const g = geometry(items.length, avail);
        orbit.style.width = `${g.size}px`;
        orbit.style.height = `${g.size}px`;
        orbit.style.setProperty('--dabi-ring-r', `${g.r}px`);
        orbit.style.setProperty('--dabi-ring-item', `${g.item}px`);
        orbit.style.setProperty('--dabi-center-size', `${g.center}px`);
        const half = g.size / 2;
        orbit.style.left = `${Math.min(Math.max(x, half + 8), window.innerWidth - half - 8)}px`;
        orbit.style.top = `${Math.min(Math.max(y, half + 8), window.innerHeight - half - 8)}px`;
      };

      const showOrbit = (card, panel) => {
        let items = (panel.dataset.orbitItems || '').split('|').filter(Boolean);
        if (items.length === 0) return hideOrbit();

        const box = card.getBoundingClientRect();
        if (box.bottom < 0 || box.top > window.innerHeight) return hideOrbit();
        const media = card.querySelector('.dabi-orbitcat__media') || card;
        const mBox = media.getBoundingClientRect();
        const cy = mBox.top + mBox.height / 2;

        // Iki yanda yer var mi?
        // Serit kenardan kenara uzandigi icin bosluk, basligin hizasindan
        // (sayfa icerik genisligi) olculuyor.
        const edge = panel.querySelector('.dabi-orbitcat__panel-head') || panel;
        const sBox = edge.getBoundingClientRect();
        const leftGutter = sBox.left;
        const rightGutter = window.innerWidth - sBox.right;
        const sides = layout === 'sides' && orbits.length > 1 && Math.min(leftGutter, rightGutter) >= minGutter;

        // Az urunde de cember dolsun: liste tekrarlanir.
        // Yanlarda iki cember var; "en az gorsel" her cember icin gecerli.
        // Ortadaki dugme yaricapi buyuttugu icin az ogede aralar aciliyordu.
        const need = sides ? minItems * 2 : minItems;
        const original = items.length;
        while (items.length < need) items = items.concat(items.slice(0, original));

        const key = `${panel.dataset.orbitcatPanel}:${sides ? 's' : 'c'}:${items.length}`;
        const groups = sides
          ? [items.filter((_, i) => i % 2 === 0), items.filter((_, i) => i % 2 === 1)]
          : [items, []];

        if (key !== orbitKey) {
          orbits.forEach((o, i) => build(o, groups[i] || []));
          orbitKey = key;
        }

        // Ortadaki "Incele" uzerine gelinen urune gider.
        const href = card.getAttribute('href');
        orbits.forEach((o) => {
          const c = o.querySelector('[data-orbitcat-center]');
          if (c && href) c.href = href;
        });

        if (sides) {
          const availL = Math.min(maxSize, leftGutter - 24);
          const availR = Math.min(maxSize, rightGutter - 24);
          placeRing(orbits[0], groups[0], leftGutter / 2, cy, availL);
          placeRing(orbits[1], groups[1], sBox.right + rightGutter / 2, cy, availR);
          orbits.forEach((o) => o.classList.add('is-visible'));
        } else {
          placeRing(orbits[0], groups[0], mBox.left + mBox.width / 2, cy, maxSize);
          orbits[0].classList.add('is-visible');
          orbits.slice(1).forEach((o) => o.classList.remove('is-visible'));
        }
        orbitOpen = true;
      };

      section.addEventListener('pointerover', (event) => {
        // Cemberin uzerinde: acik kalsin.
        if (event.target.closest('[data-orbitcat-orbit]')) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
          return;
        }
        const card = event.target.closest('.dabi-orbitcat__card');
        if (!card) {
          scheduleHide();
          return;
        }
        const panel = card.closest('[data-orbitcat-panel]');
        if (!panel) return;
        window.clearTimeout(closeTimer);
        closeTimer = null;
        window.clearTimeout(openTimer);
        openTimer = window.setTimeout(() => showOrbit(card, panel), orbitOpen ? 0 : openDelay);
      });

      // Sepet rozeti ve buyuyen onizleme sayfanin sonunda duruyor; imlec
      // onlara gecince bolumden cikmis sayilmasin.
      section.addEventListener('pointerleave', (event) => {
        const to = event.relatedTarget;
        if (to && to.closest && to.closest('[data-dabi-addbadge], [data-dabi-cardpeek], [data-dabi-snav]')) return;
        scheduleHide();
      });
      orbits.forEach((o) => {
        o.addEventListener('pointerenter', () => o.classList.add('is-paused'));
        o.addEventListener('pointerleave', () => o.classList.remove('is-paused'));
      });
      window.addEventListener('scroll', hideOrbit, { passive: true });
    };

    document.querySelectorAll('[data-dabi-orbitcat]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) =>
      initialise(event.target.querySelector('[data-dabi-orbitcat]'))
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-category-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (section) => {
      if (!section || section.dataset.dabiGalleryReady === 'true') return;
      // Dokunmatikte acilir paneller yok; serit akisi ve klavye yollari calisir.
      const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      section.dataset.dabiGalleryReady = 'true';

      const pops = Array.from(section.querySelectorAll('[data-dabi-pop-index]')).filter(
        (element) => element.classList.contains('dabi-gallery__pop')
      );
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const cards = Array.from(section.querySelectorAll('.dabi-gallery__card'));

      /* Kategori seridinin kesintisiz akisi. Kartlar iki kez basildigi icin
         yarisina gelince basa donuluyor ve dikis gorunmuyor. Uzerine
         gelindiginde duruyor: panel acilacagi icin kartin sabit kalmasi
         gerekiyor. */
      /* Popup acikken alttaki serit durur; popup kapaninca ayarlanan
         gecikmeyle devam eder. Imlec karttan popup'a gecince seridin
         pointerleave'i tetikleniyordu, bayrak onu engelliyor. */
      let popupOpen = false;
      let resumeAt = 0;
      const resumeDelay = Number(section.dataset.dabiStripResume ?? 500);

      const setupStrip = () => {
        const strip = section.querySelector('[data-dabi-strip]');
        if (!strip || strip.dataset.dabiStripAutoplay === 'on') return;
        if (section.dataset.dabiStripAutoplay !== 'true') return;

        const track = strip.querySelector('.dabi-gallery__grid');
        if (!track) return;

        strip.dataset.dabiStripAutoplay = 'on';
        const stripSpeed = Number(section.dataset.dabiStripSpeed) || 26;
        const gapOf = () => parseFloat(getComputedStyle(track).columnGap) || 0;
        const wrapAt = () => (track.scrollWidth + gapOf()) / 2;

        let stripHover = false;
        let stripLast = 0;

        strip.addEventListener('pointerenter', () => { stripHover = true; });
        strip.addEventListener('pointerleave', () => { stripHover = false; });
        strip.addEventListener('focusin', () => { stripHover = true; });
        strip.addEventListener('pointerdown', () => { stripHover = true; });

        const stripTick = (now) => {
          const wrap = wrapAt();
          if (!stripHover && !popupOpen && !section.classList.contains('is-ribbon-hover') && now >= resumeAt && !reduceMotion.matches && wrap > 0 && !strip.closest('.is-dabi-hold, .is-dabi-hold-mto, .is-dabi-hold-shelf')) {
            const delta = Math.min(now - stripLast, 60);
            strip.scrollLeft += (stripSpeed * delta) / 1000;
            if (strip.scrollLeft >= wrap) strip.scrollLeft -= wrap;
          }
          stripLast = now;
          if (strip.isConnected) window.requestAnimationFrame(stripTick);
        };

        stripLast = performance.now();
        window.requestAnimationFrame(stripTick);
      };

      setupStrip();
      // Açılır panel yoksa (ayar kapalı ya da dokunmatik) şerit akışı yine de çalışır; panel kurulumu atlanır.
      if (pops.length === 0) return;

      // Gorseller yalnizca panel ilk kez acildiginda inmeye baslar.
      const loadImages = (pop) => {
        if (pop.dataset.dabiLoaded === 'true') return;
        pop.dataset.dabiLoaded = 'true';
        pop.querySelectorAll('img[data-dabi-src]').forEach((image) => {
          image.srcset = image.dataset.dabiSrcset || '';
          image.src = image.dataset.dabiSrc;
          image.removeAttribute('data-dabi-src');
          image.removeAttribute('data-dabi-srcset');
        });
      };

      // Tema duzenleyicideki degerler: akis hizi (saniyede piksel), ok
      // tiklamasindan sonraki bekleme (saniye) ve akisin acik olup olmadigi.
      const speed = Number(section.dataset.dabiSpeed) || 50;
      const holdMs = (Number(section.dataset.dabiHold) || 0) * 1000;
      const autoplay = section.dataset.dabiAutoplay !== 'false';

      // Serit: iki ayni kopya yan yana. Bir kopyanin genisligi + aradaki bosluk
      // kadar kaydirinca ekranda birebir ayni goruntu olur, geri sarma
      // gorunmez. Toplam = 2 * kopya + bosluk oldugu icin sarma mesafesi
      // (toplam + bosluk) / 2.
      const buildSlider = (pop) => {
        const viewport = pop.querySelector('[data-dabi-pop-window]');
        const track = pop.querySelector('.dabi-gallery__pop-track');
        if (!viewport || !track) return null;

        // Serit gercekten tasmiyorsa ne akis ne ok gerekir.
        const overflows = () => track.scrollHeight > viewport.clientHeight + 4;
        const loops = track.hasAttribute('data-dabi-loop') && overflows();
        if (!loops) pop.classList.add('is-static');

        const gapOf = () => parseFloat(getComputedStyle(track).rowGap) || 0;
        const wrapAt = () => (loops ? (track.scrollHeight + gapOf()) / 2 : 0);
        const stepBy = () => {
          const item = track.querySelector('.dabi-gallery__pop-item');
          return item ? item.getBoundingClientRect().height + gapOf() : 120;
        };

        let frame = null;
        let last = null;
        let holdUntil = 0;
        let hovering = false;

        const normalise = () => {
          if (!loops) return;
          const wrap = wrapAt();
          if (wrap <= 0) return;
          if (viewport.scrollTop >= wrap) viewport.scrollTop -= wrap;
          else if (viewport.scrollTop < 0) viewport.scrollTop += wrap;
        };

        const tick = (now) => {
          const idle = hovering || now < holdUntil || reduceMotion.matches || !autoplay || !!section.closest('.is-dabi-hold, .is-dabi-hold-mto, .is-dabi-hold-shelf');
          if (last !== null && !idle && loops) {
            const delta = Math.min(now - last, 60);
            viewport.scrollTop += (speed * delta) / 1000;
          }
          normalise();
          last = now;
          frame = requestAnimationFrame(tick);
        };

        const nudge = (direction) => {
          // Ileri/geri giderken kenara dayanmasin diye once konumu ortala.
          if (loops) {
            const wrap = wrapAt();
            if (direction < 0 && viewport.scrollTop < stepBy()) viewport.scrollTop += wrap;
          }
          viewport.scrollBy({ top: direction * stepBy(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          holdUntil = performance.now() + holdMs;
        };

        pop.querySelector('[data-dabi-pop-prev]')?.addEventListener('click', () => nudge(-1));
        pop.querySelector('[data-dabi-pop-next]')?.addEventListener('click', () => nudge(1));

        pop.addEventListener('pointerenter', () => { hovering = true; });
        pop.addEventListener('pointerleave', () => { hovering = false; });
        pop.addEventListener('focusin', () => { hovering = true; });
        pop.addEventListener('focusout', (event) => {
          if (!pop.contains(event.relatedTarget)) hovering = false;
        });

        return {
          start() {
            if (frame !== null) return;
            last = null;
            frame = requestAnimationFrame(tick);
          },
          stop() {
            if (frame === null) return;
            cancelAnimationFrame(frame);
            frame = null;
          },
        };
      };

      const sliders = new Map();
      pops.forEach((pop) => {
        const slider = buildSlider(pop);
        if (slider) sliders.set(pop, slider);
      });

      // Yalnizca acik olan panelin seridi calisir; yedi panel birlikte
      // donerek bosa islemci harcamaz.
      const clear = () => {
        if (popupOpen) resumeAt = performance.now() + resumeDelay;
        popupOpen = false;
        pops.forEach((pop) => {
          pop.classList.remove('is-active');
          sliders.get(pop)?.stop();
        });
      };

      const inner = section.querySelector('.dabi-gallery__inner');

      // Panel, uzerine gelinen kartin tam uzerine yerlestiriliyor. Kart yatay
      // kaydirilabilir bir alanda oldugu icin konum her seferinde olculuyor.
      const place = (pop, card) => {
        const kart = card.getBoundingClientRect();
        const kutu = inner.getBoundingClientRect();
        const genislik = pop.offsetWidth || 260;
        const yukseklik = pop.offsetHeight || 340;

        // Kartlar kenardan kenara uzandigi icin sinir kapsayici degil ekran.
        let x = kart.left - kutu.left + kart.width / 2 - genislik / 2;
        x = Math.min(Math.max(x, 8 - kutu.left), window.innerWidth - kutu.left - genislik - 8);

        const medya = card.querySelector('.dabi-gallery__media');
        const alan = medya ? medya.getBoundingClientRect() : kart;
        let y = alan.top - kutu.top + alan.height / 2 - yukseklik / 2;
        y = Math.min(Math.max(y, 0), Math.max(0, kutu.height - yukseklik));

        pop.style.left = `${x}px`;
        pop.style.top = `${y}px`;
      };

      const activate = (index, card) => {
        const match = pops.find((pop) => pop.dataset.dabiPopIndex === index);
        if (!match) {
          clear();
          return;
        }
        loadImages(match);
        popupOpen = true;
        if (card) place(match, card);
        pops.forEach((pop) => {
          const isMatch = pop === match;
          pop.classList.toggle('is-active', isMatch);
          if (isMatch) sliders.get(pop)?.start();
          else sliders.get(pop)?.stop();
        });
      };

      if (!hoverable) return;

      cards.forEach((card) => {
        const index = card.dataset.dabiPopIndex;
        card.addEventListener('pointerenter', () => activate(index, card));
        card.addEventListener('focusin', () => activate(index, card));
      });

      // Fare kartla panel arasinda gezinirken panel kapanmasin.
      pops.forEach((pop) => {
        pop.addEventListener('pointerenter', () => {
          pop.classList.add('is-active');
          sliders.get(pop)?.start();
        });
      });

      // Imlec bolumden cikinca panel kapanir; buyuyen onizleme ya da sepet
      // rozeti bolumun disina tasabildigi icin onlarin ustu "disari" sayilmaz.
      document.addEventListener('pointerover', (event) => {
        if (!popupOpen) return;
        const n = event.target.closest ? event.target.closest('[data-dabi-snav]') : null;
        const t = (n && n.dabiOwner) || event.target; // ok üzerindeyken okun şeridi
        // yukarıdaki ürün şeridine geçince kartın paneli kapanır
        const ribbon = section.querySelector('[data-dabi-ribbon]');
        const peekFromRibbon = t.closest('[data-dabi-addbadge], [data-dabi-cardpeek]')?.dabiSource?.closest?.('[data-dabi-ribbon]');
        if ((ribbon && ribbon.contains(t)) || peekFromRibbon) { clear(); return; }
        if (section.contains(t) || t.closest('[data-dabi-addbadge], [data-dabi-cardpeek]')) return;
        clear();
      });
      section.addEventListener('focusout', (event) => {
        if (!section.contains(event.relatedTarget)) clear();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') clear();
      });
    };

    document.querySelectorAll('[data-dabi-gallery]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) =>
      initialise(event.target.querySelector('[data-dabi-gallery]'))
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-category-story"] && !Shopify.designMode) return;
  try {
    
  if (!window.dabiRevealReady) {
    window.dabiRevealReady = true;
    const reveal = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-dabi-visible', '');
          reveal.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    document.querySelectorAll('[data-dabi-reveal]').forEach((section) => reveal.observe(section));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-concierge"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dabi-cc]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const tabs = Array.from(root.querySelectorAll('[data-cc-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-cc-panel]'));
    const show = (key) => {
      tabs.forEach((t) => t.setAttribute('aria-selected', t.dataset.ccTab === key ? 'true' : 'false'));
      panels.forEach((p) => { p.hidden = p.dataset.ccPanel !== key; });
    };
    tabs.forEach((t) => t.addEventListener('click', () => show(t.dataset.ccTab)));
    // Form gönderildiyse ilgili sekmeyi açık getir
    if (window.location.hash.includes('DabiCCVideo')) show('video');

    // Seçili varyant ve soru çipleri → WhatsApp metni ve form
    const wa = root.querySelector('[data-cc-wa]');
    const body = root.querySelector('[data-cc-body]');
    const variantInput = root.querySelector('[data-cc-variant]');
    let chosen = '';
    const variantTitle = () => {
      const sel = document.querySelector('variant-selects, variant-radios');
      const checked = sel ? Array.from(sel.querySelectorAll('input:checked, select')).map((x) => x.value).join(' / ') : '';
      return checked || root.dataset.variant || '';
    };
    const updateWa = () => {
      const vt = variantTitle();
      if (variantInput) variantInput.value = vt;
      if (!wa) return;
      const parts = [root.dataset.waText];
      if (vt && vt !== 'Default Title') parts.push(`(${vt})`);
      if (chosen) parts.push(`— ${chosen}`);
      parts.push(root.dataset.url);
      wa.href = `https://wa.me/${root.dataset.wa}?text=${encodeURIComponent(parts.join(' '))}`;
    };
    root.querySelectorAll('[data-cc-q]').forEach((c) => c.addEventListener('click', () => {
      root.querySelectorAll('[data-cc-q]').forEach((x) => x.classList.toggle('is-on', x === c && !c.classList.contains('is-on')));
      chosen = c.classList.contains('is-on') ? c.dataset.ccQ : '';
      if (body && chosen && !body.value.includes(chosen)) body.value = (body.value ? `${body.value}\n` : '') + chosen;
      updateWa();
    }));
    document.addEventListener('change', (e) => { if (e.target.closest('variant-selects, variant-radios')) updateWa(); });
    updateWa();

    // Görüntülü tanıtım: önümüzdeki N gün, ayardaki iş günleri
    const daysBox = root.querySelector('[data-cc-days]');
    const dayInput = root.querySelector('[data-cc-day]');
    if (daysBox && dayInput) {
      const names = (root.dataset.dayNames || 'Paz,Pzt,Sal,Çar,Per,Cum,Cmt').split(',');
      const allowed = (root.dataset.days || '1,2,3,4,5').split(',').map((x) => Number(x.trim()));
      const ahead = Number(root.dataset.ahead) || 10;
      const months = new Intl.DateTimeFormat(document.documentElement.lang || 'tr', { month: 'short' });
      const d = new Date(); d.setHours(12, 0, 0, 0); d.setDate(d.getDate() + 1);
      let added = 0;
      for (let i = 0; i < 30 && added < ahead; i += 1, d.setDate(d.getDate() + 1)) {
        if (!allowed.includes(d.getDay())) continue;
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'dabi-cc__day'; b.setAttribute('role', 'radio');
        const iso = d.toISOString().slice(0, 10);
        b.dataset.value = `${iso} (${names[d.getDay()]})`;
        b.setAttribute('aria-checked', added === 0 ? 'true' : 'false');
        b.innerHTML = `<small>${names[d.getDay()]}</small><b>${d.getDate()}</b><span>${months.format(d)}</span>`;
        b.addEventListener('click', () => {
          daysBox.querySelectorAll('.dabi-cc__day').forEach((x) => x.setAttribute('aria-checked', x === b ? 'true' : 'false'));
          dayInput.value = b.dataset.value;
        });
        if (added === 0) dayInput.value = b.dataset.value;
        daysBox.appendChild(b);
        added += 1;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-configurator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (section) => {
      if (!section || section.dataset.dabiConfigReady === 'true') return;
      const form = section.querySelector('[data-dabi-config-form]');
      if (!form) return;
      section.dataset.dabiConfigReady = 'true';

      const canvas = section.querySelector('[data-dabi-canvas]');
      const layers = section.querySelector('[data-dabi-layers]');
      const chips = section.querySelector('[data-dabi-chips]');
      const totalOut = section.querySelector('[data-dabi-total]');
      const totalInput = section.querySelector('[data-dabi-total-input]');
      const message = section.querySelector('[data-dabi-message]');
      const missing = section.querySelector('[data-dabi-missing]');
      const base = Number(section.dataset.dabiBase || 0);

      const groups = Array.from(section.querySelectorAll('[data-dabi-group]'));
      const notes = Array.from(section.querySelectorAll('[data-dabi-note]'));

      const money = (cents) => {
        const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'tr', {
            style: 'currency',
            currency,
          }).format(cents / 100);
        } catch {
          return `${(cents / 100).toFixed(2)} ${currency}`;
        }
      };

      const selectionOf = (group) => group.querySelector('[data-dabi-choice].is-selected');

      const refresh = () => {
        let total = base;
        const lines = [];

        groups.forEach((group) => {
          const chosen = selectionOf(group);
          const input = group.querySelector('[data-dabi-group-input]');
          if (!chosen) {
            if (input) input.value = '';
            return;
          }
          const price = Number(chosen.dataset.choicePrice || 0);
          total += price;
          const label = group.dataset.groupLabel;
          const value = chosen.dataset.choiceLabel;
          if (input) input.value = price > 0 ? `${value} (+${money(price)})` : value;
          lines.push({ label, value });
        });

        notes.forEach((note) => {
          if (note.value.trim() !== '') total += Number(note.dataset.notePrice || 0);
        });

        totalOut.textContent = money(total);
        if (totalInput) totalInput.value = money(total);

        chips.innerHTML = '';
        lines.forEach((line) => {
          const item = document.createElement('li');
          item.innerHTML = `${line.label}: <b></b>`;
          item.querySelector('b').textContent = line.value;
          chips.appendChild(item);
        });

        // Katmanlı önizleme: seçeneğin üst görseli varsa tuvale bindirilir.
        layers.innerHTML = '';
        groups.forEach((group) => {
          const chosen = selectionOf(group);
          const overlay = chosen && chosen.dataset.choiceOverlay;
          if (!overlay) return;
          const image = document.createElement('img');
          image.src = overlay;
          image.alt = '';
          layers.appendChild(image);
        });
      };

      const pick = (choice) => {
        const group = choice.closest('[data-dabi-group]');
        if (!group) return;
        group.querySelectorAll('[data-dabi-choice]').forEach((other) =>
          other.classList.toggle('is-selected', other === choice)
        );
        refresh();
      };

      section.querySelectorAll('[data-dabi-choice]').forEach((choice) => {
        choice.addEventListener('click', () => pick(choice));
        choice.addEventListener('dragstart', (event) => {
          choice.classList.add('is-dragging');
          event.dataTransfer.effectAllowed = 'copy';
          event.dataTransfer.setData('text/plain', choice.dataset.choiceLabel || '');
          window.__dabiDragged = choice;
        });
        choice.addEventListener('dragend', () => {
          choice.classList.remove('is-dragging');
          window.__dabiDragged = null;
        });
      });

      notes.forEach((note) => note.addEventListener('input', refresh));

      if (canvas) {
        canvas.addEventListener('dragover', (event) => {
          event.preventDefault();
          event.dataTransfer.dropEffect = 'copy';
          canvas.classList.add('is-dropping');
        });
        canvas.addEventListener('dragleave', () => canvas.classList.remove('is-dropping'));
        canvas.addEventListener('drop', (event) => {
          event.preventDefault();
          canvas.classList.remove('is-dropping');
          if (window.__dabiDragged) pick(window.__dabiDragged);
        });
      }

      // Zorunlu gruplar secilmeden gonderilmesin.
      form.addEventListener('submit', (event) => {
        const eksik = groups
          .filter((group) => group.dataset.groupRequired === 'true' && !selectionOf(group))
          .map((group) => group.dataset.groupLabel);

        if (eksik.length > 0) {
          event.preventDefault();
          missing.hidden = false;
          missing.textContent = `${missing.dataset.prefix || ''} ${eksik.join(', ')}`.trim();
          missing.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        missing.hidden = true;

        // Secimler mesaj govdesine de yaziliyor: e-postada tek bakista okunsun.
        const ozet = groups
          .map((group) => {
            const chosen = selectionOf(group);
            return chosen ? `${group.dataset.groupLabel}: ${chosen.dataset.choiceLabel}` : null;
          })
          .filter(Boolean)
          .join('\n');
        const mevcut = message.value.trim();
        message.value = `${ozet}\n${totalOut.textContent}${mevcut ? `\n\n${mevcut}` : ''}`;
      });

      refresh();
    };

    document.querySelectorAll('[data-dabi-config]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) =>
      initialise(event.target.querySelector('[data-dabi-config]'))
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (footer) => {
      if (!footer || footer.dataset.dabiFooterReady === 'true') return;
      footer.dataset.dabiFooterReady = 'true';
      if (footer.querySelector('.dabi-footer__signature')) footer.classList.add('dabi-footer--has-signature');

      // Telefonda menu/iletisim/metin bloklari kapali akordeon; genis ekranda hep acik.
      const phone = window.matchMedia('(max-width: 749px)');
      const accs = footer.querySelectorAll('[data-dabi-footer-acc]');
      const sync = () => accs.forEach((acc, i) => {
        if (phone.matches) acc.open = i === 0 && acc.dataset.dabiTouched !== 'true' ? false : acc.dataset.dabiTouched === 'true' ? acc.open : false;
        else acc.open = true;
      });
      accs.forEach((acc) => acc.addEventListener('toggle', () => { if (phone.matches) acc.dataset.dabiTouched = 'true'; }));
      sync();
      phone.addEventListener('change', sync);

      footer.querySelector('[data-dabi-footer-top]')?.addEventListener('click', () => {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        document.querySelector('.dabi-header__brand, #MainContent')?.focus?.({ preventScroll: true });
      });
    };
    document.querySelectorAll('[data-dabi-footer]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target.querySelector('[data-dabi-footer]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (section) => {
      if (!section || section.dataset.dabiHeaderReady === 'true') return;
      section.dataset.dabiHeaderReady = 'true';
      // Chrome artik <details> icerigini display:none yerine content-visibility
      // ile gizliyor; bu da CSS animasyonlarini bastan oynatmiyor. Panel her
      // acildiginda giris animasyonu elle yeniden tetikleniyor.
      const restartEntrance = (menu) => {
        const targets = menu.querySelectorAll('.dabi-header__mega, .dabi-mega__card, .dabi-mega__col');
        targets.forEach((element) => {
          element.style.animation = 'none';
          void element.offsetWidth;
          element.style.animation = '';
        });
      };

      const menus = Array.from(section.querySelectorAll('[data-dabi-mega], [data-dabi-drop]'));
      const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      // :has() desteklemeyen eski Safari icin karartma sinifla da surulur.
      const syncOverlay = () => {
        const open = menus.some((m) => m.open && m.hasAttribute('data-dabi-mega')) || !!section.querySelector('.dabi-search > details[open]');
        section.classList.toggle('is-overlay-open', open);
      };
      section.querySelector('.dabi-search > details')?.addEventListener('toggle', syncOverlay);
      menus.forEach((menu) => {
        menu.addEventListener('toggle', () => {
          syncOverlay();
          if (!menu.open) return;
          menus.forEach((other) => { if (other !== menu) other.removeAttribute('open'); });
          restartEntrance(menu);
        });
        const parent = menu.closest('.dabi-header__nav-item--mega, .dabi-header__nav-item--group');
        const desktop = window.matchMedia('(min-width: 1200px)');
        // Menu baglantisiyla panel arasinda bir bosluk var; imlec oradan
        // gecerken aninda kapanmasin diye kapanma gecikmeli. Panel li'nin
        // icinde oldugu icin panele girince zamanlayici iptal oluyor.
        const openDelay = Number(section.dataset.megaOpen ?? 60);
        const closeDelay = Number(section.dataset.megaClose ?? 280);
        let openTimer = null;
        let closeTimer = null;
        parent?.addEventListener('pointerenter', () => {
          if (!desktop.matches || !finePointer.matches) return;
          window.clearTimeout(closeTimer);
          closeTimer = null;
          if (menu.open) return;
          openTimer = window.setTimeout(() => menu.setAttribute('open', ''), openDelay);
        });
        parent?.addEventListener('pointerleave', () => {
          if (!desktop.matches || !finePointer.matches) return;
          window.clearTimeout(openTimer);
          openTimer = null;
          closeTimer = window.setTimeout(() => menu.removeAttribute('open'), closeDelay);
        });
        // Masaustunde panel zaten uzerine gelince aciliyor; fare tiklamasi onu kapatmasin.
        // event.detail === 0 klavye (Enter/Space) demektir, orada varsayilan ac/kapa korunur.
        menu.querySelector('summary')?.addEventListener('click', (event) => {
          if (desktop.matches && finePointer.matches && event.detail > 0) event.preventDefault();
        });
      });
      document.addEventListener('click', (event) => {
        if (!section.contains(event.target)) menus.forEach((menu) => menu.removeAttribute('open'));
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') menus.forEach((menu) => menu.removeAttribute('open'));
      });

      /* ---- Kaydirinca davranis ----
         static: hep ayni boy. shrink: asagi inince kuculur. smart: kuculur,
         asagi kaydirinca gizlenir, yukari kaydirinca geri gelir. Urun/sepet
         sayfasinda ayara gore kucuk baslar. Sekme elle acar / kucultur. */
      const wrap = section.parentElement;
      const mode = section.dataset.scrollMode || 'smart';
      const compactStart = section.dataset.compactStart === 'true';
      const hideAfter = Number(section.dataset.hideAfter || 300);
      const tab = section.querySelector('[data-dabi-header-tab]');
      const drawer = section.querySelector('.dabi-header__mobile-menu');
      const rootStyle = document.documentElement.style;
      let lastY = Math.max(0, window.scrollY);
      let scrolledCompact = false;
      let hidden = false;
      let forceOpen = false;
      let forceCompact = false;
      let forceAt = 0;
      let frame = null;

      const busy = () => menus.some((menu) => menu.open) || (drawer && drawer.open) || !!section.querySelector('.dabi-search > details[open]');
      const writeBottom = () => rootStyle.setProperty('--dabi-header-bottom', `${Math.max(0, Math.round(section.getBoundingClientRect().bottom))}px`);
      // Sayfanin akisindaki yer: yalnizca kaydirma kaynakli kuculme yokken olculur.
      const writeFlow = () => { if (!scrolledCompact && wrap) wrap.style.setProperty('--dabi-header-flow', `${section.offsetHeight}px`); };

      const render = () => {
        const compact = !forceOpen && (forceCompact || compactStart || scrolledCompact);
        section.classList.toggle('is-compact', compact);
        // Baska bolumler (ekrana ekle dugmesi vb.) menunun kucuk oldugunu buradan okur.
        document.documentElement.classList.toggle('dabi-header-is-compact', compact);
        document.documentElement.classList.toggle('dabi-header-is-hidden', hidden);
        section.classList.toggle('is-hidden', hidden);
        section.classList.toggle('is-scrolled', lastY > 12);
        if (tab) {
          const open = !compact && !hidden;
          tab.setAttribute('aria-expanded', open ? 'true' : 'false');
          tab.setAttribute('aria-label', open ? tab.dataset.labelHide : tab.dataset.labelShow);
        }
        writeFlow();
        writeBottom();
        document.dispatchEvent(new CustomEvent('dabi:header:measured'));
      };

      const update = () => {
        frame = null;
        const y = Math.max(0, window.scrollY);
        const dy = y - lastY;
        lastY = y;
        // Esikler farkli: tam sinirda titremesin.
        if (mode !== 'static') scrolledCompact = scrolledCompact ? y > 40 : y > 140;
        if (forceOpen && Math.abs(y - forceAt) > 260) forceOpen = false;
        if (mode !== 'smart' || busy() || y <= hideAfter) hidden = false;
        else if (dy > 4 && !forceOpen) hidden = true;
        else if (dy < -4) hidden = false;
        render();
      };
      const queue = () => { if (frame === null) frame = window.requestAnimationFrame(update); };

      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue, { passive: true });
      section.addEventListener('transitionend', () => { writeFlow(); writeBottom(); });
      if ('ResizeObserver' in window) new ResizeObserver(() => { writeFlow(); writeBottom(); }).observe(section);

      tab?.addEventListener('click', () => {
        const collapsed = section.classList.contains('is-compact') || section.classList.contains('is-hidden');
        if (collapsed) {
          forceOpen = true;
          forceCompact = false;
          forceAt = Math.max(0, window.scrollY);
          hidden = false;
        } else {
          forceOpen = false;
          forceCompact = true;
        }
        render();
      });

      // Gizliyken imlec ekranin en ustune gelirse menu geri gelsin.
      document.addEventListener('pointermove', (event) => {
        if (!hidden || event.pointerType !== 'mouse' || event.clientY > 24) return;
        hidden = false;
        render();
      }, { passive: true });
      // Klavyeyle menuye gelinirse gizli kalmasin.
      section.addEventListener('focusin', () => { if (hidden) { hidden = false; render(); } });

      update();
    };
    document.querySelectorAll('.dabi-header').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target.querySelector('.dabi-header')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-hero"] && !Shopify.designMode) return;
  try {
    
  /* Katlanir ince baslik: dugme acar/kapar; secim oturum boyunca hatirlanir. */
  (() => {
    const setupFold = (hero) => {
      if (!hero || hero.dataset.dabiFoldReady === 'true' || !hero.dataset.dabiFold) return;
      const button = hero.querySelector('[data-dabi-fold-toggle]');
      if (!button) return;
      hero.dataset.dabiFoldReady = 'true';
      const label = button.querySelector('[data-dabi-fold-label]');
      const key = `dabi-fold-${hero.dataset.dabiFoldKey || ''}`;
      const apply = (folded, remember) => {
        hero.classList.toggle('is-folded', folded);
        button.setAttribute('aria-expanded', folded ? 'false' : 'true');
        if (label) label.textContent = folded ? button.dataset.labelShow : button.dataset.labelHide;
        if (!remember) return;
        try { window.sessionStorage.setItem(key, folded ? '1' : '0'); } catch (err) { /* depolama kapali */ }
      };
      let saved = null;
      try { saved = window.sessionStorage.getItem(key); } catch (err) { saved = null; }
      if (saved !== null && !window.Shopify?.designMode) apply(saved === '1', false);
      button.addEventListener('click', () => apply(!hero.classList.contains('is-folded'), true));
    };
    document.querySelectorAll('[data-dabi-fold]').forEach(setupFold);

    // Geri baglantisi: ayni siteden gelinmisse tarayici gecmisine, yoksa ust adima.
    document.addEventListener('click', (event) => {
      const back = event.target.closest('[data-dabi-crumbs-back]');
      if (!back) return;
      let sameSite = false;
      try { sameSite = document.referrer !== '' && new URL(document.referrer).origin === window.location.origin; } catch (err) { sameSite = false; }
      if (sameSite && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    });
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-dabi-fold]').forEach(setupFold));
  })();
  (() => {
    const initialise = (hero) => {
      if (!hero || hero.dataset.dabiHeroReady === 'true') return;
      const orbit = hero.querySelector('.dabi-hero__orbit');
      if (!orbit) return;
      hero.dataset.dabiHeroReady = 'true';

      const ring = orbit.querySelector('.dabi-hero__ring');
      const slots = orbit.querySelectorAll('.dabi-hero__slot');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const duration = Number(getComputedStyle(orbit).getPropertyValue('--dabi-orbit-duration').replace('s', '')) || 26;
      const reverse = orbit.classList.contains('dabi-hero__orbit--reverse');
      const step = slots.length > 0 ? 360 / slots.length : 90;

      let angle = 0;
      let offset = 0;        // ok dugmesinin ekledigi aci
      let target = 0;        // yumusak gecisin hedefi
      let paused = false;
      let last = null;

      const apply = () => orbit.style.setProperty('--dabi-orbit-angle', `${angle + offset}deg`);

      const frame = (now) => {
        if (last !== null) {
          const delta = Math.min(now - last, 60) / 1000;
          if (!paused && !reduceMotion.matches) {
            angle += (reverse ? -360 : 360) / duration * delta;
          }
          // Ok ile verilen aci hedefe dogru yumusak kapanir.
          if (offset !== target) {
            const fark = target - offset;
            offset += Math.abs(fark) < 0.2 ? fark : fark * Math.min(1, delta * 6);
          }
          apply();
        }
        last = now;
        if (orbit.isConnected) requestAnimationFrame(frame);
      };

      apply();
      requestAnimationFrame(frame);

      if (orbit.classList.contains('dabi-hero__orbit--pausable')) {
        orbit.addEventListener('pointerenter', () => { paused = true; });
        orbit.addEventListener('pointerleave', () => { paused = false; });
        orbit.addEventListener('focusin', () => { paused = true; });
        orbit.addEventListener('focusout', (event) => {
          if (!orbit.contains(event.relatedTarget)) paused = false;
        });
      }

      orbit.querySelector('[data-dabi-orbit-prev]')?.addEventListener('click', () => { target -= step; });
      orbit.querySelector('[data-dabi-orbit-next]')?.addEventListener('click', () => { target += step; });

      /* ---- Kart penceresi ---- */
      const sheet = hero.querySelector('[data-dabi-facet-sheet]');
      if (!sheet) return;

      const panel = sheet.querySelector('.dabi-hero__sheet-panel');
      const title = sheet.querySelector('[data-dabi-sheet-title]');
      const text = sheet.querySelector('[data-dabi-sheet-text]');
      const link = sheet.querySelector('[data-dabi-sheet-link]');
      const linkLabel = sheet.querySelector('[data-dabi-sheet-link-label]');
      let opener = null;

      let closeTimer = null;
      const close = () => {
        if (sheet.hidden) return;
        // Acildigi yana dogru kaybolur; animasyon bitince gizlenir.
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        sheet.classList.add('is-closing');
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          sheet.classList.remove('is-closing');
          sheet.hidden = true;
          hero.classList.remove('is-sheet-open');
          lockScroll(false);
          opener?.focus();
          opener = null;
        }, reduce ? 0 : 240);
      };

      /* ---- Pencere galerisi ---- */
      const media = sheet.querySelector('[data-dabi-sheet-media]');
      const stage = sheet.querySelector('[data-dabi-sheet-stage]');
      const stageImage = sheet.querySelector('[data-dabi-sheet-image]');
      const thumbs = sheet.querySelector('[data-dabi-sheet-thumbs]');
      const counter = sheet.querySelector('[data-dabi-sheet-count]');
      const cursor = sheet.querySelector('[data-dabi-sheet-cursor]');
      let shots = [];
      let shot = 0;

      const showShot = (index) => {
        if (shots.length === 0) return;
        shot = (index + shots.length) % shots.length;
        stageImage.src = shots[shot].b;
        stageImage.alt = shots[shot].a || '';
        counter.textContent = `${shot + 1} / ${shots.length}`;
        thumbs.querySelectorAll('button').forEach((button, i) =>
          button.classList.toggle('is-active', i === shot)
        );
      };

      const buildGallery = (raw) => {
        shots = [];
        try {
          shots = JSON.parse(raw || '[]');
        } catch {
          shots = [];
        }
        thumbs.innerHTML = '';
        if (shots.length === 0) {
          media.hidden = true;
          return;
        }
        media.hidden = false;
        counter.hidden = shots.length < 2;
        shots.forEach((item, i) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'dabi-hero__sheet-thumb';
          button.setAttribute('role', 'listitem');
          button.innerHTML = `<img src="${item.k}" alt="" width="64" height="64" loading="lazy">`;
          button.addEventListener('click', () => showShot(i));
          thumbs.appendChild(button);
        });
        thumbs.hidden = shots.length < 2;
        showShot(0);
      };

      const lockScroll = (on) => {
        // iOS Safari html'de overflow:hidden'i dinlemez; govde sabitlenir, konum saklanir.
        const html = document.documentElement;
        if (on) {
          html.style.setProperty('--dabi-lock-top', `${-window.scrollY}px`);
          html.dataset.dabiLockY = String(window.scrollY);
          html.classList.add('dabi-scroll-locked');
        } else {
          const y = Number(html.dataset.dabiLockY || 0);
          html.classList.remove('dabi-scroll-locked');
          html.style.removeProperty('--dabi-lock-top');
          window.scrollTo(0, y);
        }
      };

      const placeCursor = (event) => {
        if (shots.length < 2) return;
        const box = stage.getBoundingClientRect();
        const x = event.clientX - box.left;
        cursor.style.left = `${x}px`;
        cursor.style.top = `${event.clientY - box.top}px`;
        cursor.dataset.direction = x < box.width / 2 ? 'prev' : 'next';
        cursor.classList.add('is-visible');
      };

      // Imlec oku yalnizca farede; dokunmatikte gorsele dokunmak yine gecirir.
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        stage.addEventListener('pointerenter', placeCursor);
        stage.addEventListener('pointermove', placeCursor);
        stage.addEventListener('pointerleave', () => cursor.classList.remove('is-visible'));
      }
      stage.addEventListener('click', (event) => {
        if (shots.length < 2) return;
        const box = stage.getBoundingClientRect();
        showShot(shot + (event.clientX - box.left >= box.width / 2 ? 1 : -1));
      });

      hero.querySelectorAll('[data-dabi-facet]').forEach((card) => {
        card.addEventListener('click', () => {
          opener = card;
          title.textContent = card.dataset.facetHeading || '';
          text.textContent = card.dataset.facetText || '';
          buildGallery(card.dataset.facetMedia);

          const href = card.dataset.facetLink;
          if (href) {
            link.href = href;
            linkLabel.textContent = card.dataset.facetLinkLabel || card.dataset.facetHeading || '';
            link.hidden = false;
          } else {
            link.hidden = true;
          }

          window.clearTimeout(closeTimer);
          sheet.classList.remove('is-closing');
          sheet.hidden = false;
          hero.classList.add('is-sheet-open');
          lockScroll(true);
          panel.focus();
        });
      });

      document.addEventListener('keydown', (event) => {
        if (sheet.hidden || shots.length < 2) return;
        if (event.key === 'ArrowRight') showShot(shot + 1);
        if (event.key === 'ArrowLeft') showShot(shot - 1);
      });

      sheet.querySelectorAll('[data-dabi-facet-close]').forEach((button) =>
        button.addEventListener('click', close)
      );
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !sheet.hidden) close();
      });
    };

    document.querySelectorAll('.dabi-hero').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) =>
      initialise(event.target.querySelector('.dabi-hero'))
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-icon-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (section) => {
      if (!section || section.dataset.dabiIconrailReady === 'true') return;
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      const peek = section.querySelector('[data-dabi-peek]');
      if (!peek) return;
      section.dataset.dabiIconrailReady = 'true';

      const media = peek.querySelector('[data-dabi-peek-media]');
      const extra = peek.querySelector('[data-dabi-iconrail-extra]');
      const holdEl = section.closest('.shopify-section') || section;
      let showToken = 0;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const BOSLUK = 10;
      const GECIS = 850; // gorseller arasi bekleme

      let sayac = null;
      let acikOge = null; // karti acan ikon; tiklaninca onun adresine gidilir

      const gecisiDurdur = () => {
        if (sayac === null) return;
        clearInterval(sayac);
        sayac = null;
      };

      const show = (item) => {
        const kaynaklar = (item.dataset.peekImages || '').split('|').filter(Boolean);
        if (kaynaklar.length === 0) return;

        gecisiDurdur();
        acikOge = item;
        const benim = ++showToken;
        holdEl.classList.add('is-dabi-hold'); // önizleme açıkken şerit durur

        // Stokta yoksa özel sipariş rozeti (sol üst; baloncuk body'deki tek katmanda açılır)
        if (extra) {
          extra.innerHTML = '';
          if (item.dataset.dabiMtoState && window.DabiMto && window.DabiMto.badgeFor) {
            window.DabiMto.badgeFor(item.dataset.dabiMtoUrl).then((el) => {
              if (!el || benim !== showToken || acikOge !== item) return;
              el.classList.add('is-top');
              extra.appendChild(el);
            });
          }
        }

        // Gorseller ust uste yerlestiriliyor; gecis opaklikla yapiliyor ki
        // her karede yeniden indirme olmasin.
        media.innerHTML = '';
        kaynaklar.forEach((src, i) => {
          const img = document.createElement('img');
          img.src = src;
          img.alt = '';
          img.width = 320;
          img.height = 320;
          img.decoding = 'async';
          if (i > 0) img.loading = 'lazy';
          if (i === 0) img.classList.add('is-active');
          media.appendChild(img);
        });

        // Kart ikonun tam uzerinde; ekran kenarlarindan tasmasin diye
        // yatayda ve dikeyde sinirlaniyor.
        const kutu = item.getBoundingClientRect();
        const genislik = peek.offsetWidth || 160;
        const yukseklik = peek.offsetHeight || 190;
        const yariG = genislik / 2;
        const yariY = yukseklik / 2;

        let x = kutu.left + kutu.width / 2;
        let y = kutu.top + kutu.height / 2;
        x = Math.min(Math.max(x, yariG + BOSLUK), window.innerWidth - yariG - BOSLUK);
        y = Math.min(Math.max(y, yariY + BOSLUK), window.innerHeight - yariY - BOSLUK);

        peek.style.left = `${x}px`;
        peek.style.top = `${y}px`;
        peek.classList.add('is-visible');
        // Sepet rozeti bu karta tutunuyor (dabi-add-badge.js); kart yerine
        // oturunca rozet de yeniden konumlansin.
        document.dispatchEvent(new CustomEvent('dabi:peek:moved', { detail: { anchor: peek } }));

        if (kaynaklar.length > 1 && !reduceMotion.matches) {
          let index = 0;
          sayac = setInterval(() => {
            const kareler = media.querySelectorAll('img');
            index = (index + 1) % kareler.length;
            kareler.forEach((k, i) => k.classList.toggle('is-active', i === index));
          }, GECIS);
        }
      };

      const hide = () => {
        gecisiDurdur();
        holdEl.classList.remove('is-dabi-hold');
        if (!peek.classList.contains('is-visible')) return;
        showToken += 1;
        acikOge = null;
        if (extra) extra.innerHTML = '';
        peek.classList.remove('is-visible');
        document.dispatchEvent(new CustomEvent('dabi:peek:hidden', { detail: { anchor: peek } }));
      };

      section.querySelectorAll('.dabi-iconrail__item').forEach((item) => {
        // Akan seritte ikonlar yer degistirir; rozet ikona degil, sabit
        // duran buyumus karta tutunsun.
        item.dataset.dabiPeekAnchor = peek.id;
        item.addEventListener('pointerenter', () => show(item));
        item.addEventListener('focus', () => show(item));
      });

      // Imlec serit disina cikinca kart kapanir; kartin ya da rozetin ustune
      // gecmek "disari cikmak" sayilmaz, yoksa rozet tiklanamazdi.
      document.addEventListener('pointerover', (event) => {
        if (!peek.classList.contains('is-visible')) return;
        const n = event.target.closest ? event.target.closest('[data-dabi-snav]') : null;
        const t = (n && n.dabiOwner) || event.target; // ok üzerindeyken okun şeridi
        if (section.contains(t) || t.closest('[data-dabi-addbadge], .dabi-mto-layer')) return;
        hide();
      });

      // Kartin kendisi ikon gibi davranir: tiklaninca urune (ya da hizli
      // incelemeye) gider.
      peek.addEventListener('click', (event) => {
        if (event.target.closest('[data-dabi-mto]')) return; // rozet kendi bağlantısını kullanır
        if (!acikOge) return;
        if (acikOge.tagName === 'A') window.location.assign(acikOge.href);
        else acikOge.click();
      });
      section.addEventListener('focusout', (event) => {
        if (!section.contains(event.relatedTarget)) hide();
      });
      // Sabit konumlu kart sayfayla kaymaz; kaydirinca gizleniyor.
      window.addEventListener('scroll', hide, { passive: true });
      window.addEventListener('resize', hide, { passive: true });
    };

    document.querySelectorAll('.dabi-iconrail').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) =>
      initialise(event.target.querySelector('.dabi-iconrail'))
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-instagram-catalog"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.ready)return;root.dataset.ready='true';const slides=[...root.querySelectorAll('[data-category-slide]')],tabs=[...root.querySelectorAll('[data-category-tab]')],reduced=matchMedia('(prefers-reduced-motion: reduce)'),autoplay=root.dataset.autoplay==='true',interval=Number(root.dataset.interval)||5000;let index=0,timer;const render=n=>{index=(n+slides.length)%slides.length;slides.forEach((slide,i)=>{const active=i===index;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',active?'false':'true');slide.querySelector('.dabi-catalog__progress span')?.style.setProperty('--progress',(index+1)/slides.length)});tabs.forEach((tab,i)=>{tab.classList.toggle('is-active',i===index);i===index?tab.setAttribute('aria-current','true'):tab.removeAttribute('aria-current')})},stop=()=>clearInterval(timer),start=()=>{stop();if(autoplay&&!reduced.matches&&slides.length>1)timer=setInterval(()=>render(index+1),interval)};tabs.forEach(tab=>tab.addEventListener('click',()=>{render(Number(tab.dataset.categoryTab));start()}));root.querySelectorAll('[data-category-prev]').forEach(b=>b.addEventListener('click',()=>{render(index-1);start()}));root.querySelectorAll('[data-category-next]').forEach(b=>b.addEventListener('click',()=>{render(index+1);start()}));root.addEventListener('pointerenter',stop);root.addEventListener('pointerleave',start);root.addEventListener('focusin',stop);root.addEventListener('focusout',start);reduced.addEventListener('change',start);render(0);start();root.querySelectorAll('[data-product-modal]').forEach(modal=>{const gallery=modal.querySelector('[data-modal-gallery]'),media=[...modal.querySelectorAll('[data-modal-slide]')],count=modal.querySelector('[data-modal-count]');let mediaIndex=0;const showMedia=n=>{if(!media.length)return;mediaIndex=(n+media.length)%media.length;media.forEach((item,i)=>item.classList.toggle('is-active',i===mediaIndex));if(count)count.textContent=`${mediaIndex+1} / ${media.length}`};modal.querySelector('[data-modal-prev]')?.addEventListener('click',()=>showMedia(mediaIndex-1));modal.querySelector('[data-modal-next]')?.addEventListener('click',()=>showMedia(mediaIndex+1));if(media.length<2)gallery?.querySelector('.dabi-modal__gallery-controls')?.setAttribute('hidden','');showMedia(0);modal.querySelector('[data-modal-close]')?.addEventListener('click',()=>modal.close());modal.addEventListener('click',e=>{if(e.target===modal)modal.close()});modal.addEventListener('close',()=>{document.documentElement.style.overflow='';start()})});root.querySelectorAll('[data-product-open]').forEach(button=>button.addEventListener('click',()=>{const modal=root.querySelector(`#${button.dataset.dialog}`);if(!modal)return;stop();modal.showModal?.();document.documentElement.style.overflow='hidden'}))};document.querySelectorAll('[data-dabi-catalog]').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-dabi-catalog]')))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-install-app"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const host = document.querySelector('[data-dabi-install]');
    if (!host || host.dataset.dabiReady === 'true') return;
    host.dataset.dabiReady = 'true';

    const KEY = 'dabi-install-dismissed';
    const DONE = 'dabi-install-done';
    const ua = navigator.userAgent || '';
    const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isSafari = /Safari/.test(ua) && !/Chrome|CriOS|Chromium|Edg|OPR|FxiOS/.test(ua);
    const isMac = /Macintosh/.test(ua) && !isIOS;
    const read = (k) => { try { return window.localStorage.getItem(k); } catch (err) { return null; } };
    const write = (k, v) => { try { window.localStorage.setItem(k, v); } catch (err) { /* depolama kapalı */ } };

    // Yüklüyse hiç gösterme.
    if (standalone || read(DONE) === '1') return;
    // Kapatılmış mı? "Küçült" kipinde kulakçık kalır; "gizle" kipinde süre dolunca geri gelir.
    const minimizeMode = host.dataset.dismiss !== 'hide';
    const hideDays = Number(host.dataset.hideDays || 7);
    const dismissedAt = Number(read(KEY) || 0);
    const dismissed = dismissedAt > 0 && Date.now() - dismissedAt < hideDays * 86400000;
    if (dismissed && !minimizeMode) return;
    if (dismissed) host.classList.add('is-minimized');

    const sheet = host.querySelector('[data-dabi-install-sheet]');
    const openBtn = host.querySelector('[data-dabi-install-open]');
    const modes = Array.from(host.querySelectorAll('[data-dabi-install-mode]'));
    let deferredPrompt = null;

    const showMode = (name) => modes.forEach((el) => { el.hidden = el.dataset.dabiInstallMode !== name; });
    const pickMode = () => {
      if (deferredPrompt) return 'prompt';
      if (isIOS) return 'ios';
      if (isMac && isSafari) return 'mac';
      return 'generic';
    };

    const reveal = () => { if (host.hidden) { host.hidden = false; } };
    const fallback = host.dataset.fallback !== 'false';

    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      deferredPrompt = event;
      reveal();
      if (!sheet.hidden) showMode('prompt');
    });
    window.addEventListener('appinstalled', () => {
      write(DONE, '1');
      showMode('done');
      window.setTimeout(() => { close(); host.hidden = true; }, 2600);
    });

    // Yükleme olayı gelmezse (iOS, Firefox…) gecikmeden sonra yine göster.
    const delay = Number(host.dataset.delay || 2) * 1000;
    window.setTimeout(() => { if (isIOS || fallback) reveal(); }, delay);

    const lockScroll = (on) => {
      // iOS Safari html'de overflow:hidden'i dinlemez; govde sabitlenir, konum saklanir.
      const html = document.documentElement;
      if (on) {
        html.style.setProperty('--dabi-lock-top', `${-window.scrollY}px`);
        html.dataset.dabiLockY = String(window.scrollY);
        html.classList.add('dabi-scroll-locked');
      } else {
        const y = Number(html.dataset.dabiLockY || 0);
        html.classList.remove('dabi-scroll-locked');
        html.style.removeProperty('--dabi-lock-top');
        window.scrollTo(0, y);
      }
    };

    let lastFocus = null;
    const open = () => {
      lastFocus = document.activeElement;
      showMode(pickMode());
      sheet.hidden = false;
      host.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      lockScroll(true);
      (sheet.querySelector('[data-dabi-install-prompt]:not([hidden]), .dabi-install__close') || sheet).focus();
    };
    const close = () => {
      sheet.hidden = true;
      host.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      lockScroll(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };

    openBtn.addEventListener('click', open);
    host.querySelectorAll('[data-dabi-install-close]').forEach((el) => el.addEventListener('click', close));
    host.querySelector('[data-dabi-install-dismiss]')?.addEventListener('click', () => {
      write(KEY, String(Date.now()));
      if (minimizeMode) host.classList.add('is-minimized');
      else host.hidden = true;
    });
    host.querySelector('[data-dabi-install-restore]')?.addEventListener('click', () => {
      try { window.localStorage.removeItem(KEY); } catch (err) { /* depolama kapalı */ }
      host.classList.remove('is-minimized');
      openBtn.focus({ preventScroll: true });
    });
    // Sayfanın herhangi bir yerindeki [data-dabi-install-trigger] (örn. alt bilgi bağlantısı) pencereyi açar.
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-dabi-install-trigger]');
      if (!trigger) return;
      event.preventDefault();
      host.hidden = false;
      host.classList.remove('is-minimized');
      open();
    });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !sheet.hidden) close(); });

    host.querySelector('[data-dabi-install-prompt]')?.addEventListener('click', async () => {
      if (!deferredPrompt) return showMode('generic');
      const promptEvent = deferredPrompt;
      deferredPrompt = null;
      promptEvent.prompt();
      try {
        const { outcome } = await promptEvent.userChoice;
        if (outcome === 'accepted') { write(DONE, '1'); showMode('done'); window.setTimeout(() => { close(); host.hidden = true; }, 2600); }
        else close();
      } catch (err) { close(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-manifesto"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const words = [...root.querySelectorAll('.dabi-mf__w')];
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { words.forEach((w) => w.classList.add('is-on')); return; }
      let frame = null;
      const tick = () => {
        frame = null;
        const r = root.getBoundingClientRect();
        const vh = window.innerHeight;
        // bölüm görünür alanın altından ortasına gelirken 0→1
        const p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / Math.max(1, r.height * 0.9)));
        const n = Math.round(p * words.length);
        words.forEach((w, i) => w.classList.toggle('is-on', i < n));
      };
      const q = () => { if (frame === null) frame = requestAnimationFrame(tick); };
      window.addEventListener('scroll', q, { passive: true });
      window.addEventListener('resize', q, { passive: true });
      tick();
    };
    const run = () => document.querySelectorAll('[data-dabi-mf]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-media-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dabi-msl]').forEach((root) => {
    const track = root.querySelector('[data-msl-track]');
    if (!track) return;
    const step = () => (track.querySelector('.dabi-msl__item')?.getBoundingClientRect().width || 300) + 16;
    root.querySelector('[data-msl-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    root.querySelector('[data-msl-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    // fare ile sürükleme
    let down = false; let x0 = 0; let s0 = 0; let moved = false;
    track.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; x0 = e.clientX; s0 = track.scrollLeft; track.classList.add('is-dragging'); });
    track.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - x0; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = s0 - dx; });
    const up = () => { down = false; track.classList.remove('is-dragging'); };
    track.addEventListener('pointerup', up); track.addEventListener('pointerleave', up);
    track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    // videolar görünürken oynar
    const vids = track.querySelectorAll('[data-msl-video] video');
    if ('IntersectionObserver' in window && vids.length) {
      const io = new IntersectionObserver((entries) => entries.forEach((en) => { const v = en.target; if (en.isIntersecting) { v.muted = true; v.play().catch(() => {}); } else v.pause(); }), { root: track, threshold: .5 });
      vids.forEach((v) => io.observe(v));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-my-patterns"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-myp-play]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = encodeURIComponent(btn.dataset.id);
      const src = btn.dataset.provider === 'vimeo'
        ? `https://player.vimeo.com/video/${id}?autoplay=1`
        : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
      const f = document.createElement('iframe');
      f.src = src; f.title = btn.getAttribute('aria-label') || ''; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
      btn.replaceWith(f);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.dabiOfferReady === 'true') return;
      root.dataset.dabiOfferReady = 'true';
      const range = root.querySelector('[data-dabi-offer-range]');
      const amount = root.querySelector('[data-dabi-offer-amount]');
      const out = root.querySelector('[data-dabi-offer-out]');
      const hint = root.querySelector('[data-dabi-offer-hint]');
      const variantOut = root.querySelector('[data-dabi-offer-variant]');
      const min = Number(root.dataset.min) / 100;
      const max = Number(root.dataset.max) / 100;
      const free = root.dataset.free === 'true';
      const currency = root.dataset.currency || 'TRY';
      const money = (v) => { try { return new Intl.NumberFormat(document.documentElement.lang || 'tr', { style: 'currency', currency }).format(v); } catch (err) { return `${v.toFixed(2)} ${currency}`; } };
      const sync = (fromRange) => {
        let v = Number(fromRange ? range.value / 100 : amount.value);
        if (Number.isNaN(v)) v = 0;
        if (!free) {
          if (fromRange) amount.value = v.toFixed(2).replace(/\.00$/, '');
          else if (range) range.value = String(Math.round(Math.min(max, Math.max(min, v)) * 100));
          if (hint) hint.classList.toggle('is-low', v < min);
        }
        if (out) out.value = money(v);
      };
      range?.addEventListener('input', () => sync(true));
      amount?.addEventListener('input', () => sync(false));
      sync(!!range);
      // Varyant secimi degisince gizli alana yansit (Craft varyant secici URL'yi gunceller).
      document.addEventListener('change', (event) => {
        const picker = event.target.closest('variant-selects, variant-radios, .product-form__input');
        if (!picker || !variantOut) return;
        const chosen = Array.from(picker.querySelectorAll('input:checked, select')).map((el) => el.value).filter(Boolean).join(' / ');
        if (chosen) variantOut.value = chosen;
      });
    };
    document.querySelectorAll('[data-dabi-offer]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-dabi-offer]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-page-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (nav) => {
      if (!nav || nav.dataset.ready === 'true') return;
      nav.dataset.ready = 'true';
      const links = Array.from(nav.querySelectorAll('[data-pnav-link]'));
      const list = nav.querySelector('[data-pnav-list]');
      const targets = links.map((a) => document.getElementById(decodeURIComponent(a.hash.slice(1)))).filter(Boolean);
      const offset = () => (nav.getBoundingClientRect().bottom > 0 ? nav.offsetHeight : 0) + (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--dabi-header-bottom')) || 0) + 12;
      const setActive = (id) => {
        links.forEach((a) => {
          const on = a.hash.slice(1) === id;
          a.classList.toggle('is-active', on);
          if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
          if (on && list) {
            const r = a.getBoundingClientRect();
            const lr = list.getBoundingClientRect();
            if (r.left < lr.left || r.right > lr.right) list.scrollBy({ left: r.left - lr.left - 16, behavior: 'smooth' });
          }
        });
      };
      [...links, ...nav.querySelectorAll('[data-pnav-link-cta]')].forEach((a) => a.addEventListener('click', (e) => {
        if (!a.hash || a.pathname !== window.location.pathname) return;
        const t = document.getElementById(decodeURIComponent(a.hash.slice(1)));
        if (!t) return;
        e.preventDefault();
        const y = t.getBoundingClientRect().top + window.scrollY - offset();
        window.scrollTo({ top: y, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        history.replaceState(null, '', a.hash);
        setActive(t.id);
      }));
      // ekrandaki bölüm vurgulu
      const pick = () => {
        const line = offset() + 40;
        let cur = null;
        targets.forEach((t) => { if (t.getBoundingClientRect().top <= line) cur = t.id; });
        setActive(cur);
        nav.classList.toggle('is-stuck', nav.getBoundingClientRect().top <= (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--dabi-header-bottom')) || 0) + 1);
      };
      let raf = null;
      window.addEventListener('scroll', () => { if (raf) return; raf = requestAnimationFrame(() => { raf = null; pick(); }); }, { passive: true });
      pick();
    };
    document.querySelectorAll('[data-dabi-pnav]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-dabi-pnav]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-page-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (!root || root.dataset.dabiVitrinReady === 'true') return;
      root.dataset.dabiVitrinReady = 'true';
      const items = Array.from(root.querySelectorAll('[data-vitrin-item]'));
      const groups = Array.from(root.querySelectorAll('[data-vitrin-group]'));
      const total = root.querySelector('[data-vitrin-total]');
      const empty = root.querySelector('[data-vitrin-empty]');
      const clear = root.querySelector('[data-vitrin-clear]');
      const sort = root.querySelector('[data-vitrin-sort]');
      const grid = root.querySelector('[data-vitrin-grid]');
      const countLabel = root.dataset.labelCount || '[count]';
      const state = {};
      const money = (cents) => {
        const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY';
        try { return new Intl.NumberFormat(document.documentElement.lang || 'tr', { style: 'currency', currency, maximumFractionDigits: 0 }).format(cents / 100); } catch (err) { return `${Math.round(cents / 100)} ${currency}`; }
      };

      // Kartlardan kendiliginden turetilen gruplar: tur, etiket, fiyat.
      const build = (group) => {
        const kind = group.dataset.vitrinGroup;
        const box = group.querySelector('[data-vitrin-options]');
        if (!box || !box.dataset.vitrinAuto) return;
        const counts = new Map();
        items.forEach((it) => {
          if (kind === 'type' && it.dataset.type) counts.set(it.dataset.type, (counts.get(it.dataset.type) || 0) + 1);
          if (kind === 'tag') (it.dataset.tags || '').split('|').filter(Boolean).forEach((t) => counts.set(t, (counts.get(t) || 0) + 1));
        });
        let options = [];
        if (kind === 'price') {
          const prices = items.map((it) => Number(it.dataset.price) || 0).filter((p) => p > 0).sort((a, b) => a - b);
          if (prices.length > 3) {
            const q = (f) => prices[Math.min(prices.length - 1, Math.floor(prices.length * f))];
            const edges = [0, q(0.33), q(0.66), Infinity];
            options = [0, 1, 2].map((i) => ({ value: `${edges[i]}-${edges[i + 1]}`, label: edges[i + 1] === Infinity ? `${money(edges[i])}+` : `${money(edges[i])} – ${money(edges[i + 1])}` }));
          }
        } else {
          options = Array.from(counts.entries()).filter(([, n]) => kind !== 'tag' || n >= 2).sort((a, b) => b[1] - a[1]).slice(0, 14).map(([v]) => ({ value: v, label: v }));
        }
        if (options.length < 2) { group.hidden = true; return; }
        options.forEach((o) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'dabi-vitrin__opt';
          b.dataset.vitrinOpt = '';
          b.dataset.value = o.value;
          b.setAttribute('aria-pressed', 'false');
          b.innerHTML = `<span>${o.label}</span><small data-vitrin-count></small>`;
          box.appendChild(b);
        });
      };
      groups.forEach(build);

      const matches = (it, skipKind) => groups.every((g) => {
        const kind = g.dataset.vitrinGroup;
        if (kind === skipKind) return true;
        const sel = state[kind];
        if (!sel || sel.size === 0) return true;
        if (kind === 'collection') return sel.has(it.dataset.collection);
        if (kind === 'type') return sel.has(it.dataset.type);
        if (kind === 'tag') { const tags = (it.dataset.tags || '').split('|'); return Array.from(sel).some((t) => tags.includes(t)); }
        if (kind === 'price') { const p = Number(it.dataset.price) || 0; return Array.from(sel).some((r) => { const [a, b] = r.split('-').map(Number); return p >= a && (b === Infinity || Number.isNaN(b) || p < b || r.endsWith('Infinity')); }); }
        return true;
      });

      const apply = () => {
        let shown = 0;
        items.forEach((it) => { const ok = matches(it); it.hidden = !ok; if (ok) shown += 1; });
        if (total) total.textContent = countLabel.replace('[count]', String(shown));
        if (empty) empty.hidden = shown > 0;
        let any = false;
        groups.forEach((g) => {
          const kind = g.dataset.vitrinGroup;
          const sel = state[kind] || new Set();
          if (sel.size) any = true;
          g.classList.toggle('is-set', sel.size > 0);
          const v = g.querySelector('[data-vitrin-value]');
          if (v) v.textContent = sel.size ? Array.from(sel).map((x) => g.querySelector(`[data-vitrin-opt][data-value="${CSS.escape(x)}"] span`)?.textContent || x).join(', ') : '';
          g.querySelectorAll('[data-vitrin-opt]').forEach((b) => {
            b.setAttribute('aria-pressed', sel.has(b.dataset.value) ? 'true' : 'false');
            // Sayac: bu secenek secilirse kac urun kalir (kendi grubu haric diger filtrelerle).
            const n = items.filter((it) => matches(it, kind) && (kind === 'collection' ? it.dataset.collection === b.dataset.value : kind === 'type' ? it.dataset.type === b.dataset.value : kind === 'tag' ? (it.dataset.tags || '').split('|').includes(b.dataset.value) : (() => { const p = Number(it.dataset.price) || 0; const [a, bb] = b.dataset.value.split('-'); return p >= Number(a) && (bb === 'Infinity' || p < Number(bb)); })())).length;
            const c = b.querySelector('[data-vitrin-count]');
            if (c) c.textContent = n;
            b.classList.toggle('is-empty', n === 0);
          });
        });
        if (clear) clear.hidden = !any;
        root.querySelector('[data-vitrin-rail]')?.classList.toggle('is-set', any);
      };

      /* Serit: farede uzerine gelince gecikmeyle acilir, cikinca kapanir (dokunmatikte tiklama). */
      const rail = root.querySelector('[data-vitrin-rail]');
      const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      const desktop = window.matchMedia('(min-width: 990px)');
      if (rail) {
        const openDelay = Number(root.dataset.railOpen || 220);
        const closeDelay = Number(root.dataset.railClose || 450);
        let openTimer = null;
        let closeTimer = null;
        rail.addEventListener('pointerenter', () => {
          window.clearTimeout(closeTimer);
          if (!fine.matches || !desktop.matches || rail.open) return;
          openTimer = window.setTimeout(() => { rail.open = true; }, openDelay);
        });
        rail.addEventListener('pointerleave', () => {
          window.clearTimeout(openTimer);
          if (!fine.matches || !desktop.matches || !rail.open) return;
          closeTimer = window.setTimeout(() => {
            const active = document.activeElement;
            if (active && rail.contains(active) && active.matches('input')) return;
            rail.open = false;
          }, closeDelay);
        });
        if ('IntersectionObserver' in window && grid) {
          new IntersectionObserver((entries) => {
            rail.classList.toggle('is-rail-hidden', !entries.some((e) => e.isIntersecting));
          }, { rootMargin: '0px 0px -12% 0px' }).observe(grid);
        }
      }

      root.addEventListener('click', (event) => {
        const opt = event.target.closest('[data-vitrin-opt]');
        if (!opt) return;
        const kind = opt.closest('[data-vitrin-group]').dataset.vitrinGroup;
        state[kind] = state[kind] || new Set();
        if (state[kind].has(opt.dataset.value)) state[kind].delete(opt.dataset.value); else state[kind].add(opt.dataset.value);
        apply();
      });
      clear?.addEventListener('click', () => { Object.keys(state).forEach((k) => state[k].clear()); apply(); });

      sort?.addEventListener('change', () => {
        const mode = sort.value;
        const sorted = items.slice().sort((a, b) => {
          if (mode === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
          if (mode === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
          if (mode === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title, document.documentElement.lang || 'tr');
          return items.indexOf(a) - items.indexOf(b);
        });
        sorted.forEach((it) => grid.appendChild(it));
      });

      apply();
    };
    document.querySelectorAll('[data-dabi-vitrin]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target.querySelector('[data-dabi-vitrin]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-product-recs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const boot = (sec) => {
      if (!sec || sec.dataset.ready) return;
      sec.dataset.ready = '1';
      const track = sec.querySelector('[data-dabi-prec-track]');
      const tabs = sec.querySelector('[data-dabi-prec-tabs]');
      const recentTrack = sec.querySelector('[data-dabi-prec-recent]');
      const strips = () => { if (window.DabiStrips) window.DabiStrips.init(sec); };
      let hasRecs = !track.querySelector('.dabi-prec__ghost');
      let hasRecent = false;

      const showTabs = () => {
        if (hasRecs && hasRecent) tabs.hidden = false;
        if (!hasRecs && hasRecent) select('recent');
        if (!hasRecs && !hasRecent) sec.hidden = true;
      };
      const select = (name) => {
        sec.querySelectorAll('[data-dabi-prec-tab]').forEach((t) => t.setAttribute('aria-selected', String(t.dataset.dabiPrecTab === name)));
        sec.querySelectorAll('[data-dabi-prec-panel]').forEach((p) => { p.hidden = p.dataset.dabiPrecPanel !== name; });
        strips();
      };
      tabs.addEventListener('click', (e) => { const t = e.target.closest('[data-dabi-prec-tab]'); if (t) select(t.dataset.dabiPrecTab); });

      const recs = hasRecs
        ? Promise.resolve()
        : fetch(sec.dataset.url).then((r) => r.text()).then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const src = doc.querySelector('[data-dabi-prec-track]');
            const cards = src ? src.querySelectorAll('[data-pcard]') : [];
            if (cards.length) { track.innerHTML = src.innerHTML; hasRecs = true; } else { track.innerHTML = ''; sec.querySelector('[data-dabi-prec-panel="recs"]').hidden = true; }
          }).catch(() => { track.innerHTML = ''; });

      let handles = [];
      if (sec.dataset.showRecent === 'true') {
        try { handles = JSON.parse(localStorage.getItem('dabi-recent') || '[]'); } catch (e) { handles = []; }
        handles = handles.filter((h) => h !== sec.dataset.handle).slice(0, parseInt(sec.dataset.limit, 10) || 8);
      }
      const root = window.Shopify?.routes?.root || '/';
      const recent = handles.length
        ? Promise.all(handles.map((h) => fetch(`${root}products/${encodeURIComponent(h)}?view=dabi-card`).then((r) => (r.ok ? r.text() : '')).catch(() => ''))).then((parts) => {
            const html = parts.filter((p) => p.includes('data-pcard')).join('');
            if (html) { recentTrack.innerHTML = html; hasRecent = true; }
          })
        : Promise.resolve();

      Promise.all([recs, recent]).then(() => { showTabs(); strips(); document.dispatchEvent(new CustomEvent('dabi:cards-added', { detail: { root: sec } })); });
    };

    const run = () => document.querySelectorAll('[data-dabi-prec]').forEach((sec) => {
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => { if (entries.some((e) => e.isIntersecting)) { io.disconnect(); boot(sec); } }, { rootMargin: '600px 0px' });
        io.observe(sec);
      } else boot(sec);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (section) => {
      if (!section || section.dataset.dabiRailsReady === 'true') return;
      section.dataset.dabiRailsReady = 'true';
      section.querySelectorAll('[data-dabi-rail]').forEach((rail) => {
        const viewport = rail.querySelector('[data-rail-viewport]');
        const previous = rail.querySelector('[data-rail-prev]');
        const next = rail.querySelector('[data-rail-next]');
        const progress = rail.querySelector('[data-rail-progress]');
        if (!viewport) return;
        const update = () => {
          const maximum = viewport.scrollWidth - viewport.clientWidth;
          const ratio = maximum > 0 ? viewport.scrollLeft / maximum : 1;
          if (previous) previous.disabled = viewport.scrollLeft <= 2;
          if (next) next.disabled = viewport.scrollLeft >= maximum - 2;
          if (progress) progress.style.setProperty('--rail-progress', Math.max(.2, ratio));
        };
        previous?.addEventListener('click', () => viewport.scrollBy({ left: -viewport.clientWidth * .82, behavior: 'smooth' }));
        next?.addEventListener('click', () => viewport.scrollBy({ left: viewport.clientWidth * .82, behavior: 'smooth' }));
        viewport.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        update();
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) { rail.classList.add('is-visible'); observer.disconnect(); }
            });
          }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
          observer.observe(rail);
        } else { rail.classList.add('is-visible'); }
      });
    };
    document.querySelectorAll('[data-dabi-rails]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target.querySelector('[data-dabi-rails]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-scroll-note"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dabi-scroll]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const key = `dabi-scroll-closed:${root.dataset.id}`;
    const miniKey = `dabi-scroll-mini:${root.dataset.id}`;
    const miniMode = root.dataset.closeMode !== 'hide';
    if (!miniMode) {
      try { if (Number(localStorage.getItem(key) || 0) > Date.now()) return; } catch (err) { /* yok */ }
    }
    root.hidden = false;
    const setMini = (on) => {
      root.classList.toggle('is-mini', on);
      try { if (on) localStorage.setItem(miniKey, '1'); else localStorage.removeItem(miniKey); } catch (err) { /* yok */ }
    };
    if (miniMode) { try { root.classList.toggle('is-mini', localStorage.getItem(miniKey) === '1'); } catch (err) { /* yok */ } }
    const tab = root.querySelector('[data-scroll-toggle]');
    const hoverMode = root.dataset.openOn === 'hover' && window.matchMedia('(hover: hover)').matches;
    let t = null;
    const set = (open) => { root.classList.toggle('is-open', open); tab.setAttribute('aria-expanded', open ? 'true' : 'false'); };
    tab.addEventListener('click', () => {
      // küçük sekmeye basınca: normal hâline döner ve açılır
      if (root.classList.contains('is-mini')) { setMini(false); set(true); return; }
      set(!root.classList.contains('is-open'));
    });
    if (hoverMode) {
      root.addEventListener('pointerenter', () => { window.clearTimeout(t); if (!root.classList.contains('is-mini')) set(true); });
      root.addEventListener('pointerleave', () => { t = window.setTimeout(() => set(false), 350); });
    }
    root.querySelector('[data-scroll-close]')?.addEventListener('click', (e) => {
      e.stopPropagation();
      set(false);
      if (miniMode) { setMini(true); tab.focus({ preventScroll: true }); return; }
      root.hidden = true;
      try { localStorage.setItem(key, String(Date.now() + 86400000)); } catch (err) { /* yok */ }
    });
    document.addEventListener('pointerdown', (e) => { if (!root.contains(e.target)) set(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') set(false); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (section) => {
      if (!section || section.dataset.dabiShowcaseReady === 'true') return;
      const viewer = section.querySelector('[data-dabi-showcase-viewer]');
      if (!viewer) return;
      section.dataset.dabiShowcaseReady = 'true';

      const panel = viewer.querySelector('.dabi-showcase__viewer-panel');
      const stage = viewer.querySelector('[data-dabi-showcase-stage]');
      const image = viewer.querySelector('[data-dabi-showcase-image]');
      const caption = viewer.querySelector('[data-dabi-showcase-caption]');
      const cursor = viewer.querySelector('[data-dabi-showcase-cursor]');
      const shots = Array.from(section.querySelectorAll('[data-dabi-shot]'));
      let index = 0;
      let opener = null;

      const show = (next) => {
        if (shots.length === 0) return;
        index = (next + shots.length) % shots.length;
        image.src = shots[index].dataset.shotFull;
        image.alt = shots[index].dataset.shotAlt || '';
        caption.textContent = shots[index].dataset.shotAlt || '';
      };

      const close = () => {
        viewer.hidden = true;
        lockScroll(false);
        opener?.focus();
        opener = null;
      };

      shots.forEach((shot, i) => {
        shot.addEventListener('click', () => {
          opener = shot;
          show(i);
          viewer.hidden = false;
          lockScroll(true);
          panel.focus();
        });
      });

      const lockScroll = (on) => {
        // iOS Safari html'de overflow:hidden'i dinlemez; govde sabitlenir, konum saklanir.
        const html = document.documentElement;
        if (on) {
          html.style.setProperty('--dabi-lock-top', `${-window.scrollY}px`);
          html.dataset.dabiLockY = String(window.scrollY);
          html.classList.add('dabi-scroll-locked');
        } else {
          const y = Number(html.dataset.dabiLockY || 0);
          html.classList.remove('dabi-scroll-locked');
          html.style.removeProperty('--dabi-lock-top');
          window.scrollTo(0, y);
        }
      };

      const place = (event) => {
        if (shots.length < 2) return;
        const box = stage.getBoundingClientRect();
        const x = event.clientX - box.left;
        cursor.style.left = `${x}px`;
        cursor.style.top = `${event.clientY - box.top}px`;
        cursor.dataset.direction = x < box.width / 2 ? 'prev' : 'next';
        cursor.classList.add('is-visible');
      };

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        stage.addEventListener('pointerenter', place);
        stage.addEventListener('pointermove', place);
        stage.addEventListener('pointerleave', () => cursor.classList.remove('is-visible'));
      }
      stage.addEventListener('click', (event) => {
        if (shots.length < 2) return;
        const box = stage.getBoundingClientRect();
        show(index + (event.clientX - box.left >= box.width / 2 ? 1 : -1));
      });

      viewer.querySelectorAll('[data-dabi-showcase-close]').forEach((button) =>
        button.addEventListener('click', close)
      );
      document.addEventListener('keydown', (event) => {
        if (viewer.hidden) return;
        if (event.key === 'Escape') close();
        if (event.key === 'ArrowRight') show(index + 1);
        if (event.key === 'ArrowLeft') show(index - 1);
      });
    };

    document.querySelectorAll('[data-dabi-showcase]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) =>
      initialise(event.target.querySelector('[data-dabi-showcase]'))
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-sticky-buy"] && !Shopify.designMode) return;
  try {
    
  (() => {
  const initializeDabiStickyBuy = (bar) => {
    if (bar.dataset.dabiStickyReady === 'true') return;
    const stickyButton = bar.querySelector('[data-dabi-sticky-button]');
    const mainButton = document.querySelector('product-form [name="add"]');
    if (!stickyButton || !mainButton) return;
    bar.dataset.dabiStickyReady = 'true';
    const syncState = () => {
      stickyButton.disabled = mainButton.disabled;
      stickyButton.setAttribute('aria-disabled', mainButton.disabled ? 'true' : 'false');
    };
    stickyButton.addEventListener('click', () => mainButton.click());
    const observer = new IntersectionObserver(([entry]) => {
      const visible = !entry.isIntersecting;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      // yüzen düğme kümesi (paylaş, kampanya) çubuğun üstüne çıkar
      document.documentElement.style.setProperty('--dabi-dock-bottom', visible ? `${bar.offsetHeight}px` : '0px');
    }, { threshold: 0.1 });
    observer.observe(mainButton);
    const stateObserver = new MutationObserver(syncState);
    stateObserver.observe(mainButton, { attributes: true, attributeFilter: ['disabled'] });
    syncState();
  };

  document.querySelectorAll('[data-dabi-sticky-buy]').forEach(initializeDabiStickyBuy);
  document.addEventListener('shopify:section:load', (event) => {
    const bar = event.target.querySelector('[data-dabi-sticky-buy]');
    if (bar) initializeDabiStickyBuy(bar);
  });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-story-scroll"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const steps = root.querySelectorAll('[data-ss-step]');
      if (!('IntersectionObserver' in window) || steps.length < 2) return;
      const set = (i) => {
        root.querySelectorAll('[data-ss-year]').forEach((y) => y.classList.toggle('is-on', y.dataset.ssYear === String(i)));
        root.querySelectorAll('[data-ss-dot]').forEach((d) => d.classList.toggle('is-on', d.dataset.ssDot === String(i)));
      };
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) set(e.target.dataset.ssStep); });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      steps.forEach((s) => io.observe(s));
    };
    const run = () => document.querySelectorAll('[data-dabi-ss]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-story-timeline"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dabi-stl]').forEach((list) => {
    const items = Array.from(list.querySelectorAll('[data-stl-item]'));
    if (!('IntersectionObserver' in window)) { items.forEach((i) => i.classList.add('is-on')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-on'); io.unobserve(e.target); } });
    }, { threshold: .25, rootMargin: '0px 0px -10% 0px' });
    items.forEach((i) => io.observe(i));
    const fill = () => {
      const r = list.getBoundingClientRect();
      const vh = window.innerHeight;
      const p = Math.min(1, Math.max(0, (vh * .6 - r.top) / r.height));
      list.style.setProperty('--dabi-stl-fill', `${Math.round(p * 100)}%`);
    };
    let raf = 0;
    window.addEventListener('scroll', () => { if (raf) return; raf = window.requestAnimationFrame(() => { raf = 0; fill(); }); }, { passive: true });
    fill();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-video-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dabi-vh]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const slides = Array.from(root.querySelectorAll('[data-vh-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-vh-dot]'));
    const interval = Math.max(3, Number(root.dataset.interval) || 7) * 1000;
    root.style.setProperty('--dabi-vh-int', `${interval / 1000}s`);
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection && navigator.connection.saveData;
    const phone = window.matchMedia('(max-width: 749px)').matches;
    // Telefon ve veri tasarrufu: poster kalır, video yüklenmez (ayar açıksa telefonda da oynar).
    const allowVideo = !saveData && (!phone || root.dataset.autoplay === 'true');
    let i = 0; let timer = null; let visible = true;

    const playVideo = (slide) => {
      if (!allowVideo) return;
      const v = slide.querySelector('[data-vh-video] video');
      if (v) { v.muted = true; v.play().then(() => slide.querySelector('[data-vh-video]').classList.add('is-playing')).catch(() => {}); }
      const e = slide.querySelector('[data-vh-embed]');
      if (e && !e.querySelector('iframe')) {
        const f = document.createElement('iframe');
        f.src = e.dataset.src; f.title = ''; f.setAttribute('allow', 'autoplay; encrypted-media'); f.setAttribute('aria-hidden', 'true'); f.tabIndex = -1;
        f.addEventListener('load', () => e.classList.add('is-playing'));
        e.appendChild(f);
      }
    };
    const stopVideo = (slide) => {
      const v = slide.querySelector('[data-vh-video] video');
      if (v) { v.pause(); slide.querySelector('[data-vh-video]').classList.remove('is-playing'); }
    };
    const go = (n) => {
      const prev = slides[i];
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.setAttribute('aria-selected', k === i ? 'true' : 'false'));
      if (prev !== slides[i]) stopVideo(prev);
      playVideo(slides[i]);
      restart();
    };
    const restart = () => {
      window.clearTimeout(timer);
      if (slides.length > 1 && !reduced && visible && !root.classList.contains('is-paused')) timer = window.setTimeout(() => go(i + 1), interval);
    };
    root.querySelector('[data-vh-next]')?.addEventListener('click', () => go(i + 1));
    root.querySelector('[data-vh-prev]')?.addEventListener('click', () => go(i - 1));
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
    root.addEventListener('pointerenter', () => { root.classList.add('is-paused'); window.clearTimeout(timer); });
    root.addEventListener('pointerleave', () => { root.classList.remove('is-paused'); restart(); });
    // dokunmatik kaydırma
    let x0 = null;
    root.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); x0 = null; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
        if (visible) { playVideo(slides[i]); restart(); } else { stopVideo(slides[i]); window.clearTimeout(timer); }
      }, { threshold: .2 }).observe(root);
    } else { playVideo(slides[i]); restart(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-volume-calc"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const cfg = root.dataset;
      const read = (sel) => { try { return JSON.parse(root.querySelector(sel).textContent || '[]'); } catch (e) { return []; } };
      const products = read('[data-vcalc-products]');
      const tiers = read('[data-vcalc-tiers]').map((t) => ({ ...t, min: Number(t.min) || 0, off: t.off === null || t.off === '' ? null : Number(t.off) })).filter((t) => t.min > 0).sort((a, b) => a.min - b.min);
      const q = (s) => root.querySelector(s);
      const sel = q('[data-vcalc-product]');
      const img = q('[data-vcalc-img]');
      const qty = q('[data-vcalc-qty]');
      const range = q('[data-vcalc-range]');
      const ladder = q('[data-vcalc-ladder]');
      if (!products.length || !tiers.length) { q('.dabi-vcalc__card').hidden = true; q('[data-vcalc-empty]').hidden = false; return; }
      const fmt = (cfg.moneyFormat || '{' + '{amount}}').replace(/<[^>]*>/g, '');
      const group = (n, s) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, s);
      const money = (cents) => {
        const v = (Number(cents) || 0) / 100;
        const [i, f] = v.toFixed(2).split('.');
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
          if (k === 'amount_with_comma_separator') return `${group(i, '.')},${f}`;
          if (k === 'amount_no_decimals') return group(Math.round(v), ',');
          if (k === 'amount_no_decimals_with_comma_separator') return group(Math.round(v), '.');
          return `${group(i, ',')}.${f}`;
        });
      };
      products.forEach((p, i) => { const o = document.createElement('option'); o.value = String(i); o.textContent = p.t; sel.appendChild(o); });
      ladder.innerHTML = tiers.map((t) => `<li><b>${t.min}+</b><small></small></li>`).join('');
      ladder.querySelectorAll('li').forEach((li, i) => { li.querySelector('small').textContent = tiers[i].name || ''; });
      const maxQ = Math.max(Number(range.max) || 200, tiers[tiers.length - 1].min);
      range.max = String(maxQ);
      const T = (s, map) => String(s || '').replace(/\{(\w+)\}/g, (m, k) => (k in map ? map[k] : m));
      let summary = '';
      const render = () => {
        const p = products[Number(sel.value) || 0];
        const n = Math.max(1, Math.round(Number(qty.value) || 1));
        if (img) { img.hidden = !p.i; if (p.i) img.src = p.i; }
        range.value = String(Math.min(n, maxQ));
        let cur = -1;
        tiers.forEach((t, i) => { if (n >= t.min) cur = i; });
        ladder.querySelectorAll('li').forEach((li, i) => { li.classList.toggle('is-reached', i <= cur); li.classList.toggle('is-current', i === cur); });
        const t = cur >= 0 ? tiers[cur] : null;
        const next = tiers[cur + 1];
        q('[data-vcalc-tiername]').textContent = t ? T(cfg.lTier, { name: t.name || `${t.min}+` }) : T(cfg.lBelow, { min: tiers[0].min });
        const retail = p.p * n;
        const hasOff = t && t.off !== null && !Number.isNaN(t.off);
        const unit = hasOff ? Math.round(p.p * (1 - t.off / 100)) : p.p;
        const small = (txt) => { const s = document.createElement('small'); s.className = 'dabi-vcalc__sub'; s.textContent = txt; return s; };
        const unitEl = q('[data-vcalc-unit]');
        unitEl.innerHTML = hasOff ? `<s>${money(p.p)}</s>${money(unit)}` : money(p.p);
        if (!hasOff && t && cfg.lQuote) unitEl.appendChild(small(cfg.lQuote));
        const totalEl = q('[data-vcalc-total]');
        totalEl.textContent = money(hasOff ? unit * n : retail);
        if (!hasOff && cfg.lRetail) totalEl.appendChild(small(cfg.lRetail));
        q('[data-vcalc-saverow]').hidden = !hasOff;
        if (hasOff) q('[data-vcalc-save]').textContent = money(retail - unit * n);
        q('[data-vcalc-leadrow]').hidden = !(t && t.lead);
        if (t && t.lead) q('[data-vcalc-lead]').textContent = t.lead;
        const perk = q('[data-vcalc-perk]');
        perk.hidden = !(t && t.perk);
        if (t && t.perk) perk.textContent = t.perk;
        const nx = q('[data-vcalc-next]');
        if (next) { nx.hidden = false; nx.textContent = T(cfg.lNext, { n: next.min - n, name: next.name || `${next.min}+`, off: next.off !== null ? `%${next.off}` : '' }).replace(/\s+·\s*$/, ''); }
        else { nx.hidden = !cfg.lTop; nx.textContent = cfg.lTop || ''; }
        summary = T(cfg.lMsg, { product: p.t, qty: n, tier: t ? (t.name || `${t.min}+`) : '-', url: window.location.origin + p.u });
        const wa = q('[data-vcalc-wa]');
        if (wa && cfg.wa) wa.href = `https://wa.me/${cfg.wa}?text=${encodeURIComponent(summary)}`;
      };
      sel.addEventListener('change', render);
      qty.addEventListener('input', render);
      range.addEventListener('input', () => { qty.value = range.value; render(); });
      root.querySelectorAll('[data-vcalc-step]').forEach((b) => b.addEventListener('click', () => { qty.value = String(Math.max(1, (Math.round(Number(qty.value) || 1)) + Number(b.dataset.vcalcStep))); render(); }));
      const quote = q('[data-vcalc-quote]');
      if (quote) quote.addEventListener('click', (e) => {
        const form = cfg.form && document.getElementById(cfg.form);
        if (!form) return;
        e.preventDefault();
        const ta = form.querySelector('textarea');
        if (ta) ta.value = ta.value ? `${ta.value}\n${summary}` : summary;
        const head = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--dabi-header-bottom')) || 0;
        window.scrollTo({ top: form.getBoundingClientRect().top + window.scrollY - head - 70, behavior: 'smooth' });
        window.setTimeout(() => { const f = form.querySelector('input:not([type=hidden]), textarea'); if (f) f.focus({ preventScroll: true }); }, 600);
      });
      render();
    };
    document.querySelectorAll('[data-dabi-vcalc]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-dabi-vcalc]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-wholesale-form"] && !Shopify.designMode) return;
  try {
    
  // dabi-whf-prefill: ürün sayfasındaki toptan panelinden gelen ürün ve adet notu forma yazılır
  (() => {
    const q = new URLSearchParams(window.location.search);
    const urun = q.get('urun'); const adet = q.get('adet');
    if (!urun && !adet) return;
    document.querySelectorAll('#DabiWholesaleForm textarea[name="contact[body]"]').forEach((t) => {
      if (!t.value) t.value = `${urun || ''}${adet ? ` — ${adet} adet` : ''}\n`;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-wholesale-quick-order"] && !Shopify.designMode) return;
  try {
    
  const roots = document.querySelectorAll('[data-dabi-whq]');
  const fmt = (cents, f) => {
    const n = (Number(cents) || 0) / 100;
    const m = (f || '').match(/\{\{\s*(\w+)\s*\}\}/);
    const key = m ? m[1] : 'amount';
    const parts = (dec, thou, d) => { let [i, fr] = n.toFixed(d).split('.'); i = i.replace(/\B(?=(\d{3})+(?!\d))/g, thou); return fr !== undefined ? i + dec + fr : i; };
    let out;
    switch (key) {
      case 'amount_no_decimals': out = parts('', ',', 0); break;
      case 'amount_with_comma_separator': out = parts(',', '.', 2); break;
      case 'amount_no_decimals_with_comma_separator': out = parts('', '.', 0); break;
      default: out = parts('.', ',', 2);
    }
    return f ? f.replace(/\{\{\s*\w+\s*\}\}/, out) : out;
  };
  roots.forEach((root) => {
    const rows = Array.from(root.querySelectorAll('[data-whq-row]'));
    if (rows.length === 0) return;
    const count = root.querySelector('[data-whq-count]');
    const total = root.querySelector('[data-whq-total]');
    const add = root.querySelector('[data-whq-add]');
    const status = root.querySelector('[data-whq-status]');
    const search = root.querySelector('[data-whq-search]');
    const recalc = () => {
      let c = 0; let t = 0;
      rows.forEach((r) => {
        const q = Math.max(0, parseInt(r.querySelector('[data-whq-qty]').value, 10) || 0);
        const line = q * Number(r.dataset.price);
        r.classList.toggle('has-qty', q > 0);
        r.querySelector('[data-whq-line]').textContent = q > 0 ? fmt(line, root.dataset.moneyFormat) : '—';
        c += q; t += line;
      });
      count.textContent = c;
      total.textContent = c > 0 ? fmt(t, root.dataset.moneyFormat) : '—';
      add.disabled = c === 0;
    };
    rows.forEach((r) => r.querySelector('[data-whq-qty]').addEventListener('input', recalc));
    search?.addEventListener('input', () => {
      const q = search.value.trim().toLowerCase();
      rows.forEach((r) => { r.hidden = q !== '' && !r.dataset.name.toLowerCase().includes(q); });
    });
    add.addEventListener('click', async () => {
      const items = rows.map((r) => ({ id: Number(r.dataset.variant), quantity: parseInt(r.querySelector('[data-whq-qty]').value, 10) || 0 })).filter((i) => i.quantity > 0);
      if (items.length === 0) return;
      add.disabled = true; status.textContent = '…';
      try {
        const res = await fetch(`${root.dataset.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!res.ok) throw new Error('add');
        const cart = await fetch(`${root.dataset.root || '/'}cart.js`).then((r) => r.json());
        status.textContent = root.dataset.labelAdded;
        if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'dabi-wholesale-quick-order', cartData: cart });
        rows.forEach((r) => { r.querySelector('[data-whq-qty]').value = 0; });
        recalc();
        document.getElementById('cart-icon-bubble')?.click();
      } catch (err) {
        status.textContent = root.dataset.labelError;
        add.disabled = false;
      }
    });
    recalc();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dabi-workshops"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fmtMoney = (cents, f) => {
      const n = (Number(cents) || 0) / 100;
      const m = (f || '').match(/\{\{\s*(\w+)\s*\}\}/);
      const key = m ? m[1] : 'amount';
      const parts = (dec, thou, d) => { let [i, fr] = n.toFixed(d).split('.'); i = i.replace(/\B(?=(\d{3})+(?!\d))/g, thou); return fr !== undefined ? i + dec + fr : i; };
      let out;
      switch (key) {
        case 'amount_no_decimals': out = parts('', ',', 0); break;
        case 'amount_with_comma_separator': out = parts(',', '.', 2); break;
        case 'amount_no_decimals_with_comma_separator': out = parts('', '.', 0); break;
        default: out = parts('.', ',', 2);
      }
      return f ? f.replace(/\{\{\s*\w+\s*\}\}/, out) : out;
    };

    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      /* Seviye süzgeci */
      const items = Array.from(root.querySelectorAll('.dabi-ws__item'));
      const none = root.querySelector('[data-ws-none]');
      root.querySelectorAll('[data-ws-filter]').forEach((chip) => {
        chip.addEventListener('click', () => {
          const f = chip.dataset.wsFilter;
          root.querySelectorAll('[data-ws-filter]').forEach((c) => {
            const on = c === chip;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-pressed', String(on));
          });
          let shown = 0;
          items.forEach((it) => {
            const ok = f === 'all' || it.dataset.level === f;
            it.hidden = !ok;
            if (ok) shown += 1;
          });
          if (none) none.hidden = shown > 0;
        });
      });

      /* Sepete ekleme */
      const addVariant = async (id, qty = 1, props = {}) => {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = new FormData();
        body.append('id', id);
        body.append('quantity', qty);
        Object.entries(props).forEach(([k, v]) => { if (v) body.append(`properties[${k}]`, v); });
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.append('sections', cart.getSectionsToRender().map((s) => s.id));
          body.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        const url = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const res = await fetch(url, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
        const data = await res.json();
        if (data.status) throw new Error(data.description || data.message);
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'dabi-workshops', productVariantId: String(id), cartData: data });
        }
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(data);
        }
      };

      root.querySelectorAll('[data-ws-card]').forEach((card) => {
        const book = card.querySelector('[data-ws-book]');
        const buy = card.querySelector('[data-ws-buy]');
        const msg = card.querySelector('[data-ws-msg]');
        const qtyInput = card.querySelector('[data-ws-qty-input]');
        const nameInput = card.querySelector('[data-ws-name]');
        const sum = card.querySelector('[data-ws-sum]');
        if (!book) return;
        const say = (text, bad) => { if (!msg) return; msg.textContent = text; msg.classList.toggle('is-bad', !!bad); msg.hidden = false; };
        const selected = () => card.querySelector('[data-ws-variant]:checked');
        const selectedId = () => selected()?.value || book.dataset.single || '';
        const qty = () => Math.max(1, Math.min(Number(qtyInput?.max) || 99, Number(qtyInput?.value) || 1));
        const updateSum = () => {
          if (!sum) return;
          const price = Number(selected()?.dataset.price || card.dataset.price || 0);
          const n = qty();
          sum.innerHTML = price ? `${n} ${root.dataset.labelPeople || ''}<b>${fmtMoney(price * n, root.dataset.moneyFormat)}</b>` : '';
        };
        card.querySelectorAll('[data-ws-qty]').forEach((b) => b.addEventListener('click', () => {
          if (!qtyInput) return;
          qtyInput.value = String(Math.max(1, Math.min(Number(qtyInput.max) || 99, (Number(qtyInput.value) || 1) + Number(b.dataset.wsQty))));
          updateSum();
        }));
        qtyInput?.addEventListener('input', updateSum);
        card.querySelectorAll('[data-ws-variant]').forEach((r) => r.addEventListener('change', () => {
          book.disabled = false;
          if (buy) buy.disabled = false;
          if (msg) msg.hidden = true;
          updateSum();
        }));
        updateSum();
        const run = async (btn, thenCheckout) => {
          const id = selectedId();
          if (!id) { say(root.dataset.labelChoose, true); card.querySelector('[data-ws-strip]')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); return; }
          btn.classList.add('is-busy');
          btn.disabled = true;
          const props = {};
          if (nameInput && nameInput.value.trim()) props[root.dataset.nameKey || 'Katılımcı'] = nameInput.value.trim();
          try {
            await addVariant(id, qty(), props);
            if (thenCheckout) { window.location.assign(`${root.dataset.root || '/'}checkout`); return; }
            say(root.dataset.labelAdded, false);
          } catch (err) {
            say(err.message || root.dataset.labelError, true);
          }
          btn.classList.remove('is-busy');
          btn.disabled = false;
        };
        book.addEventListener('click', () => run(book, false));
        if (buy) buy.addEventListener('click', () => run(buy, true));
      });

      /* Yaklaşan oturumlar: sığmıyorsa sonsuz akış (kopya + %50 kayma) */
      const upVp = root.querySelector('[data-ws-up]');
      const upList = root.querySelector('[data-ws-up-list]');
      if (upVp && upList && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const originals = Array.from(upList.children);
        if (originals.length > 1 && upList.scrollWidth > upVp.clientWidth - 8) {
          originals.forEach((li) => {
            const c = li.cloneNode(true);
            c.setAttribute('data-ws-clone', '');
            c.setAttribute('aria-hidden', 'true');
            c.querySelectorAll('button').forEach((b) => b.setAttribute('tabindex', '-1'));
            upList.appendChild(c);
          });
          const speed = Number(root.dataset.upSpeed) || 30;
          upList.style.setProperty('--dabi-ws-up-dur', `${Math.max(18, Math.round(upList.scrollWidth / 2 / speed))}s`);
          upVp.classList.add('is-marquee');
          upVp.addEventListener('pointerdown', () => upVp.classList.add('is-paused'));
          ['pointerup', 'pointercancel', 'pointerleave'].forEach((ev) => upVp.addEventListener(ev, () => upVp.classList.remove('is-paused')));
        }
      }

      /* Yaklaşan oturumlar → kartta tarihi seç */
      root.querySelectorAll('[data-ws-jump]').forEach((b) => b.addEventListener('click', () => {
        const item = root.querySelector(`#ws-${b.dataset.wsJump}`);
        if (!item) return;
        if (item.hidden) root.querySelector('[data-ws-filter="all"]')?.click();
        const radio = item.querySelector(`[data-ws-variant][value="${b.dataset.wsJumpVariant}"]`);
        if (radio && !radio.disabled) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          radio.closest('.dabi-ws__date')?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        item.scrollIntoView({ behavior: 'smooth', block: 'start' });
        item.classList.add('is-flash');
        window.setTimeout(() => item.classList.remove('is-flash'), 1600);
      }));

      /* Telefonda "Tarihleri gör" */
      const sticky = root.querySelector('[data-ws-sticky]');
      if (sticky && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(([e]) => {
          sticky.hidden = e.isIntersecting || e.boundingClientRect.top < 0;
        }, { threshold: 0.05 });
        io.observe(root);
      }
    };
    document.querySelectorAll('[data-dabi-ws]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-dabi-ws]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
